<template>
  <div id="data-pasien">
    <h4 class="text-capitalize mb-3 ">
      data pasien
      <span v-if="idPasien && formData">
        (no. rekam medis: {{ formData.nomor_rekam_medis }})
      </span>
    </h4>
    <b-form>
      <b-container fluid>
        <div class="row justify-content-center">
          <div class="col-sm-12 ">
            <div
              class="card-body"
              style="background: rgb(186 219 251); padding:0.5rem; border-radius:5px; margin-bottom: 10px"
            >
              <b-row>
                <b-col
                  sm="1"
                  class="text-center mt-2"
                  style="padding-right: 5px;"
                >
                  <font-awesome-icon
                    size="3x"
                    style="color: #5565f3; height:40px"
                    icon="clipboard-list"
                  />
                </b-col>
                <b-col
                  sm="11"
                  class="mt-2"
                  style="padding-left: 0px; font-size: 14px; color: #004c8d"
                >
                  <label class="mt-2">
                    <strong>
                      Anda dapat mengisi kolom yang wajib diisi saja / bertanda
                      * merah. Kolom lain bersifat optional untuk diisi.</strong
                    >
                  </label>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
        <div class="accordion mt-4" role="tablist">
          <div
            :class="{
              'section-error': section1Error,
              'personal-information': true
            }"
          >
            <div
              class="row pointer"
              @click="visible_section_1 = !visible_section_1"
            >
              <div class="col-md font-weight-bold">
                IDENTITAS PRIBADI <span class="text-red">*</span>
              </div>
              <div class="col-md text-right">
                <font-awesome-icon
                  class="fs-24"
                  :icon="['fas', 'chevron-down']"
                  :class="{
                    'rotate-0': visible_section_1,
                    'rotate-90': !visible_section_1
                  }"
                />
              </div>
            </div>
            <hr />
            <b-collapse
              id="accordion-1"
              v-model="visible_section_1"
              accordion="my-accordion"
              role="tabpanel"
            >
              <div class="row mb-4">
                <!-- nama lengkap -->
                <b-col sm="6">
                  <b-form-group
                    class="text-capitalize pos-relative"
                    :state="stateNamaLengkap"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'nama lengkap'
                        })
                      })
                    "
                  >
                    <label for="">{{
                      renderLabel({ label: "nama lengkap sesuai KTP" })
                    }}</label>
                    <label class="text-red"> *</label>
                    <b-form-input
                      @keyup="
                        setValue({
                          rawLabel: 'nama lengkap',
                          $event
                        }); 
                        nama_touched = true;
                      "
                      id="nama_lengkap"
                      ref="nama_lengkap"
                      :state="stateNamaLengkap"
                      :disabled="disabledForm()"
                      :value="getValue('nama lengkap')"
                      :maxlength="60"
                    />
                  </b-form-group>
                </b-col>
                <!-- no rm manual -->
                <b-col sm="6">
                  <b-form-group
                    class="text-capitalize pos-relative"
                    :state="stateRmManual"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'No. RM Manual'
                        })
                      })
                    "
                  >
                    <label for="">{{
                      renderLabel({ label: "No. RM Manual" })
                    }}</label>
                    <b-form-input
                      @keyup="
                        setValue({
                          rawLabel: 'No. RM Manual',
                          $event
                        })
                      "
                      id="No._RM_Manual"
                      ref="no_rm_manual"
                      :state="stateRmManual"
                      :disabled="disabledForm()"
                      :value="getValue('No. RM Manual')"
                      :maxlength="15"
                    />
                  </b-form-group>
                </b-col>
                <!-- status perkawinan -->
                <b-col sm="6">
                  <b-form-group
                    :label="renderLabel({ label: 'status perkawinan' })"
                    class="text-capitalize pos-relative"
                  >
                    <vue-select
                      :options="[
                        'Belum Kawin',
                        'Kawin',
                        'Cerai Hidup',
                        'Cerai Mati'
                      ]"
                      @input="
                        setValue({
                          rawLabel: 'status perkawinan',
                          $event
                        })
                      "
                      :disabled="disabledForm()"
                      :value="getValue('status perkawinan')"
                    />
                  </b-form-group>
                </b-col>
                <!-- no handphone -->
                <b-col sm="6">
                  <b-form-group
                    class="text-capitalize pos-relative"
                    :state="stateHandphone"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'no. handphone'
                        })
                      })
                    "
                  >
                    <label for="">{{
                      renderLabel({ label: "no. handphone" })
                    }}</label>
                    <label class="text-red"> *</label>
                    <b-input-group>
                      <template #prepend>
                        <vue-select
                          id="noHpTypeId"
                          :options="noHpOptions"
                          v-model="noHpType"
                          @input="onInputChangeNoType"
                          style="border-radius: 5px 0px 0px 5px; width: 200px"
                          class="country-code-mask"
                        />
                      </template>
                      <b-form-input
                        @keypress="
                          onKeyInputNumber({
                            rawLabel: 'no. handphone',
                            $event
                          })
                        "
                        @keyup="
                          setValue({
                            rawLabel: 'no. handphone',
                            $event
                          });
                          handphone_touched = true;
                        "
                        id="no._handphone"
                        ref="no_handphone"
                        :state="stateHandphone"
                        :disabled="disabledForm()"
                        :value="getValue('no. handphone')"
                        :maxlength="13"
                        style="border-radius: 0px 5px 5px 0px;"
                      />
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <!-- jenis identitas -->
                <b-col sm="6" lg="3">
                  <b-form-group
                    class="text-capitalize pos-relative"
                    :state="getDataError({ rawLabel: 'jenis identitas' })"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'jenis identitas'
                        })
                      })
                    "
                  >
                    <label>Jenis Identitas</label>
                    <label class="text-red" v-if="!isForgotNik || (!isLessThan17 && !this.isForgotNik)"> *</label>
                    <vue-select
                      :options="['KTP', 'KITAS', 'Paspor']"
                      @input="
                        setValue({
                          rawLabel: 'jenis identitas',
                          $event
                        });
                        onInputJenisIdentitas();
                      "
                      :disabled="disabledForm()"
                      :value="getValue('jenis identitas')"
                    />
                  </b-form-group>
                </b-col>
                <!-- nik -->
                <b-col sm="6" lg="3">
                  <b-form-group
                    id="fieldset-no-identitas"
                    valid-feedback=""
                    :invalid-feedback="invalidFeedbackNoIdentitas"
                    :state="stateNoIdentitas"
                  >
                    <label>No. identitas</label>
                    <label class="text-red" v-if="!isForgotNik || (!isLessThan17 && !this.isForgotNik)"> *</label>
                    <b-form-input
                      id="nik"
                      ref="nik"
                      v-model="formData.nik"
                      :state="stateNoIdentitas"
                      :disabled="disabledForm()"
                      @keypress="onKeyInputNumberBPJS({ $event })"
                      @input="onInputNik"
                      :maxlength="maxlengthNik"
                    ></b-form-input>
                  </b-form-group>
                  <div class="d-flex justify-content-between" v-if="!isLessThan17 || isFirstLoad">
                    <span>Lupa No. Identitas</span>
                    <toggle-button v-model="isForgotNik" sync @change="switchForgotNik(isForgotNik)" :labels="{ checked: ' Ya', unchecked: ' Tidak' }"
                      :width="60" :height="20" :color="{
                        checked: '#41c70e',
                        unchecked: '#f83245',
                        disabled: '#CCCCCC'
                      }" class="float-right" />
                  </div>
                </b-col>
                <!-- email -->
                <b-col sm="6">
                  <b-form-group
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'email'
                        })
                      })
                    "
                    :state="stateEmail"
                    class="text-capitalize pos-relative"
                  >
                    <label for="">{{
                      renderLabel({ label: "email" })
                    }}</label>
                    <b-form-input
                      @keyup="
                        setValue({
                          rawLabel: 'email',
                          $event
                        })
                      "
                      :state="stateEmail"
                      :disabled="disabledForm()"
                      :value="getValue('email')"
                      :maxlength="30"
                      :invalid-feedback="
                        renderInvalidFeedback({
                          validationDesc: blindlyGetData({
                            rawLabel: 'email'
                          })
                        })
                      "
                    />
                  </b-form-group>
                </b-col>
                <!-- jenis kelamin -->
                <b-col sm="6" lg="3">
                  <b-form-group
                    class="text-capitalize pos-relative"
                    :state="getDataError({ rawLabel: 'jenis kelamin' })"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'jenis kelamin'
                        })
                      })
                    "
                  >
                    <label for="">{{
                      renderLabel({ label: "jenis kelamin" })
                    }}</label>
                    <label class="text-red"> *</label>
                    <vue-select
                      :options="[
                        'Laki-laki',
                        'Perempuan',
                        'Tidak diketahui',
                        'Tidak dapat ditentukan',
                        'Tidak mengisi'
                      ]"
                      @input="
                        setValue({
                          rawLabel: 'jenis kelamin',
                          $event
                        })
                      "
                      :disabled="disabledForm()"
                      :value="getValue('jenis kelamin')"
                    />
                  </b-form-group>
                </b-col>
                <!-- golongan darah -->
                <b-col sm="6" lg="3">
                  <b-form-group
                    class="text-capitalize pos-relative"
                    :state="getDataError({ rawLabel: 'gol. darah' })"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'gol. darah'
                        })
                      })
                    "
                  >
                    <label for="">{{
                      renderLabel({ label: "gol. darah" })
                    }}</label>
                    <vue-select
                      :options="['A', 'B', 'AB', 'O', 'Tidak Diketahui']"
                      @input="
                        setValue({
                          rawLabel: 'gol. darah',
                          $event
                        })
                      "
                      :disabled="disabledForm()"
                      :value="getValue('gol. darah')"
                    />
                  </b-form-group>
                </b-col>
                <!-- no bpjs -->
                <b-col sm="6">
                  <b-row style="margin-top: 10px">
                    <b-col
                      :sm="bpjsAuthValid ? 8 : 12"
                      :class="
                        card_number.error
                          ? 'col-sm-8 top_form_err'
                          : 'col-sm-8 top_form'
                      "
                    >
                      <b-form-group>
                        <label>No. Kartu BPJS/NIK</label>
                        <b-form-input
                          ref="card_number"
                          type="text"
                          v-model="card_number.number"
                          :class="{
                            '__kategori-select is-invalid': card_number.error
                          }"
                          @keypress="onKeyInputNumberBPJS({ $event })"
                          @input="
                            onCardNumber();
                            cek_anggota_bpjs = false;
                          "
                          :disabled="disabledForm() || isEditBPJS"
                        />
                        <b-form-invalid-feedback v-if="card_number.error">
                          {{ card_number.message }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4" class="btn_bpjs" v-show="bpjsAuthValid">
                      <b-button
                        @click="cekPesertaBPJS()"
                        variant="primary"
                        :disabled="disabledForm() || isEditBPJS"
                      >
                        Cek Peserta</b-button
                      >
                    </b-col>
                  </b-row>
                </b-col>
                <!-- tanggal lahir -->
                <b-col sm="6" lg="3">
                  <b-form-group
                    class="text-capitalize"
                    style="position: relative"
                    :state="getDataError({ rawLabel: 'tanggal lahir' })"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'tanggal lahir'
                        })
                      })
                    "
                  >
                    <label for="">{{
                      renderLabel({ label: "tanggal lahir" })
                    }}</label>
                    <label class="text-red"> *</label>

                    <DatePickerX
                      v-model="formData.tanggal_lahir"
                      style="cursor"
                      :popover="{
                        placement: 'auto',
                        visibility: 'click',
                        positionFixed: true
                      }"
                      mode="single"
                      :input-props="{
                        placeholder: 'Pilih Tanggal',
                        readonly: true
                      }"
                      :masks="{ input: 'DD-MM-YYYY' }"
                      :is-required="true"
                      :maxDate="new Date()"
                    >
                      <template v-slot="{ inputValue, inputEvents }">
                        <b-form-input
                          :value="inputValue"
                          v-on="inputEvents"
                          :readonly="true"
                          :style="
                            !disabledForm() ? 'background-color:#ffffff;' : ''
                          "
                          :disabled="disabledForm()"
                        ></b-form-input>
                        <font-awesome-icon
                          icon="calendar"
                          class="cal-pos"
                        />
                      </template>
                    </DatePickerX>
                  </b-form-group>
                </b-col>
                <!-- tempat lahir -->
                <b-col sm="6" lg="3">
                  <b-form-group
                    class="text-capitalize pos-relative"
                    :state="stateTempatLahir"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'tempat lahir'
                        })
                      })
                    "
                  >
                    <label for="">{{
                      renderLabel({ label: "tempat lahir" })
                    }}</label>
                    <label class="text-red"> *</label>
                    <b-form-input
                      @keyup="
                        setValue({
                          rawLabel: 'tempat lahir',
                          $event
                        })
                      "
                      @keypress="
                        onKeyInputPreventSymbol({
                          $event
                        })
                        tempat_lahir_touched = true
                      "
                      id="tempat_lahir"
                      ref="tempat_lahir"
                      :state="stateTempatLahir"
                      :disabled="disabledForm()"
                      :value="getValue('tempat lahir')"
                    />
                  </b-form-group>
                </b-col>
                <!-- nik ibu -->
                <b-col sm="3" v-if="isLessThan17 && !isFirstLoad">
                  <b-form-group
                    id="fieldset-no-identitas-ibu"
                    valid-feedback=""
                    :invalid-feedback="invalidFeedbackNoIdentitasIbu"
                    :state="stateNoIdentitasIbu"
                  >
                    <label>No. KTP Ibu Kandung</label>
                    <label class="text-red"> *</label>
                    <b-form-input
                      id="nik-ibu"
                      ref="nik_ibu"
                      v-model="formData['no._KTP_ibu_kandung']"
                      :state="stateNoIdentitasIbu"
                      :disabled="disabledForm()"
                      @keypress="onKeyInputNumberBPJS({ $event })"
                      @input="onInputNikIbu"
                      :maxlength="maxlengthNik"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <!-- nama ibu kandung -->
                <b-col :class="{'col-sm-3' : isLessThan17, 'col-sm-6' : !isLessThan17}">
                  <b-form-group
                    class="text-capitalize pos-relative"
                    :state="getDataError({ rawLabel: 'nama ibu kandung' })"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'nama ibu kandung'
                        })
                      })
                    "
                  >
                    <label for="">{{
                      renderLabel({ label: "nama ibu kandung" })
                    }}</label>
                    <b-form-input
                      @keyup="
                        setValue({
                          rawLabel: 'nama ibu kandung',
                          $event
                        })
                      "
                      :disabled="disabledForm()"
                      :value="getValue('nama ibu kandung')"
                    />
                  </b-form-group>
                </b-col>
                <!-- agama -->
                <b-col sm="6" lg="3">
                  <b-form-group
                    :label="renderLabel({ label: 'agama' })"
                    class="text-capitalize pos-relative"
                    :state="getDataError({ rawLabel: 'agama' })"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'agama'
                        })
                      })
                    "
                  >
                    <vue-select
                      :options="[
                        'Islam',
                        'Kristen (Protestan)',
                        'Katolik',
                        'Hindu',
                        'Buddha',
                        'Khonghucu'
                      ]"
                      @input="
                        setValue({
                          rawLabel: 'agama',
                          $event
                        })
                      "
                      :disabled="disabledForm()"
                      :value="getValue('agama')"
                    />
                  </b-form-group>
                </b-col>
                <!-- suku -->
                <b-col sm="6" lg="3">
                  <b-form-group
                    :label="renderLabel({ label: 'suku' })"
                    class="text-capitalize pos-relative"
                    :state="getDataError({ rawLabel: 'suku' })"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'suku'
                        })
                      })
                    "
                  >
                    <b-form-input
                      @keyup="
                        setValue({
                          rawLabel: 'suku',
                          $event
                        })
                      "
                      @keypress="
                        onKeyInputPreventSymbol({
                          $event
                        })
                      "
                      :disabled="disabledForm()"
                      :value="getValue('suku')"
                    />
                  </b-form-group>
                </b-col>
                <!-- bahasa yang dikuasai -->
                <b-col sm="6">
                  <b-form-group
                    :label="renderLabel({ label: 'bahasa yang dikuasai' })"
                    class="text-capitalize pos-relative"
                    :state="getDataError({ rawLabel: 'bahasa yang dikuasai' })"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'bahasa yang dikuasai'
                        })
                      })
                    "
                  >
                    <b-form-input
                      @keyup="
                        setValue({
                          rawLabel: 'bahasa yang dikuasai',
                          $event
                        })
                      "
                      :disabled="disabledForm()"
                      :value="getValue('bahasa yang dikuasai')"
                    />
                  </b-form-group>
                </b-col>
              </div>
            </b-collapse>
          </div>
          <div
            :class="{
              'section-error': section2Error,
              'ktp-address': true
            }"
          >
            <div
              class="row pointer"
              @click="visible_section_2 = !visible_section_2"
            >
              <div class="col-md font-weight-bold">
                ALAMAT SESUAI KTP <span class="text-red">*</span>
              </div>
              <div class="col-md text-right">
                <font-awesome-icon
                  class="fs-24"
                  :icon="['fas', 'chevron-down']"
                  :class="{
                    'rotate-0': visible_section_2,
                    'rotate-90': !visible_section_2
                  }"
                />
              </div>
            </div>
            <hr />
            <b-collapse
              id="accordion-2"
              v-model="visible_section_2"
              accordion="my-accordion"
              role="tabpanel"
            >
              <div class="row mb-4">
                <!-- negara -->
                <b-col sm="6">
                  <b-form-group
                    class="text-capitalize pos-relative"
                    :state="stateNegara"
                    invalid-feedback="Negara Harus Diisi"
                  >
                    <label for="">{{ renderLabel({ label: "negara" }) }}</label>
                    <label class="text-red"> *</label>
                    <vue-select
                      ref="ref_negara"
                      :options="countries"
                      :disabled="disabledForm()"
                      v-model="tempat.negara"
                      @input="onInputNegara"
                    />
                  </b-form-group>
                </b-col>
                <!-- privinsi -->
                <b-col sm="6">
                  <b-form-group
                    lass="text-capitalize pos-relative"
                    :state="stateProvinsi"
                    invalid-feedback="Provinsi Harus Diisi"
                  >
                    <label>Provinsi</label>
                    <label class="text-red"> *</label>
                    <vue-select
                      :options="provinces"
                      @input="getCity"
                      :disabled="disabledForm()"
                      v-model="tempat.provinsi"
                    />
                  </b-form-group>
                </b-col>
                <!-- kota -->
                <b-col sm="6">
                  <b-form-group
                    class="text-capitalize pos-relative"
                    :state="stateKota"
                    invalid-feedback="Kota Harus Diisi"
                  >
                    <label>Kotamadya / Kabupaten</label>
                    <label class="text-red"> *</label>
                    <vue-select
                      :options="cities"
                      v-model="tempat.kota"
                      @input="setDataTempat"
                      :disabled="disabledForm()"
                    />
                  </b-form-group>
                </b-col>
                <!-- kecamatan -->
                <b-col sm="6">
                  <b-form-group
                    class="text-capitalize pos-relative"
                    :state="stateKecamatan"
                    invalid-feedback="Kecamatan Harus Diisi"
                  >
                    <label>Kecamatan</label>
                    <label class="text-red"> *</label>
                    <vue-select
                      :options="kecamatanOption"
                      v-model="tempat.kecamatan"
                      @input="setDataTempatKecamatan"
                      :disabled="disabledForm()"
                    />
                  </b-form-group>
                </b-col>
                <!-- desa -->
                <b-col sm="6">
                  <b-form-group
                    class="text-capitalize pos-relative"
                    :state="stateKelurahan"
                    invalid-feedback="Kelurahan Harus Diisi"
                  >
                    <label>Kelurahan / Desa</label>
                    <label class="text-red"> *</label>
                    <vue-select
                      :options="kelurahanOption"
                      v-model="tempat.kelurahan"
                      @input="setDataTempatKelurahan"
                      :disabled="disabledForm()"
                    />
                  </b-form-group>
                </b-col>
                <!-- kode pos -->
                <b-col sm="6">
                  <b-form-group
                    :label="renderLabel({ label: 'kode pos' })"
                    class="text-capitalize pos-relative"
                    :state="getDataError({ rawLabel: 'kode pos' })"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'kode pos'
                        })
                      })
                    "
                  >
                    <b-form-input
                      @keypress="
                        onKeyInputNumber({
                          rawLabel: 'kode pos',
                          $event
                        })
                      "
                      @keyup="
                        setValue({
                          rawLabel: 'kode pos',
                          $event
                        })
                      "
                      :disabled="disabledForm()"
                      :value="getValue('kode pos')"
                    />
                  </b-form-group>
                </b-col>
                <!-- alamat rumah -->
                <b-col sm="6">
                  <b-form-group
                    class="text-capitalize pos-relative"
                    :state="stateAlamatLengkap"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'alamat rumah'
                        })
                      })
                    "
                  >
                    <label for="">{{
                      renderLabel({ label: "alamat lengkap" })
                    }}</label>
                    <label class="text-red"> *</label>
                    <b-form-textarea
                      @keyup="
                        setValue({
                          rawLabel: 'alamat rumah',
                          $event
                        });
                        alamat_rumah_touched = true;
                      "
                      id="alamat_rumah"
                      rows="3"
                      ref="alamat"
                      :state="stateAlamatLengkap"
                      :disabled="disabledForm()"
                      :value="getValue('alamat rumah')"
                      :maxlength="100"
                    />
                  </b-form-group>
                </b-col>
                <!-- rt -->
                <b-col sm="6" lg="3">
                  <b-form-group
                    :label="renderLabel({ label: 'Rukun Tetangga /RT' })"
                    class="text-capitalize pos-relative"
                    :state="getDataError({ rawLabel: 'rt' })"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'rt'
                        })
                      })
                    "
                  >
                    <b-form-input
                      @keypress="
                        onKeyInputNumber({
                          rawLabel: 'rt',
                          $event
                        })
                      "
                      @keyup="
                        setValue({
                          rawLabel: 'rt',
                          $event
                        })
                      "
                      :disabled="disabledForm()"
                      :value="getValue('rt')"
                      :maxlength="3"
                    />
                  </b-form-group>
                </b-col>
                <!-- rw -->
                <b-col sm="6" lg="3">
                  <b-row>
                    <b-col>
                      <b-form-group
                        :label="renderLabel({ label: 'Rukun Warga /RW' })"
                        class="text-capitalize pos-relative"
                        :state="getDataError({ rawLabel: 'rw' })"
                        :invalid-feedback="
                          renderInvalidFeedback({
                            validationDesc: blindlyGetData({
                              rawLabel: 'rw'
                            })
                          })
                        "
                      >
                        <b-form-input
                          @keypress="
                            onKeyInputNumber({
                              rawLabel: 'rw',
                              $event
                            })
                          "
                          @keyup="
                            setValue({
                              rawLabel: 'rw',
                              $event
                            })
                          "
                          :disabled="disabledForm()"
                          :value="getValue('rw')"
                          :maxlength="3"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="text-right">
                      <div class="d-inline-flex">
                        <label for="checkbox-alamat-domi" class=" mr-2"
                          >Alamat sesuai KTP</label
                        >
                        <b-form-checkbox
                          id="checkbox-alamat-domi"
                          v-model="alamatDomisiliSesuaiKTP"
                          name="checkbox-1"
                          value="1"
                          unchecked-value="0"
                          @input="onClickCheckboxDomi"
                        >
                        </b-form-checkbox>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </div>
            </b-collapse>
          </div>
          <div class="domisili-address">
            <div
              class="row pointer"
              @click="visible_section_3 = !visible_section_3"
            >
              <div class="col-md font-weight-bold">
                ALAMAT DOMISILI
              </div>
              <div class="col-md text-right">
                <font-awesome-icon
                  class="fs-24"
                  :icon="['fas', 'chevron-down']"
                  :class="{
                    'rotate-0': visible_section_3,
                    'rotate-90': !visible_section_3
                  }"
                />
              </div>
            </div>
            <hr />
            <b-collapse
              id="accordion-3"
              v-model="visible_section_3"
              accordion="my-accordion"
              role="tabpanel"
            >
              <div class="row mb-4">
                <!-- negara domi -->
                <b-col sm="6">
                  <b-form-group
                    class="text-capitalize pos-relative"
                    :state="getDataError({ rawLabel: 'negara domi' })"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'negara domi'
                        })
                      })
                    "
                  >
                    <label for="">{{ renderLabel({ label: "negara" }) }}</label>
                    <vue-select
                      :options="countries"
                      :disabled="disabledForm() || alamatDomisiliSesuaiKTP == 1"
                      v-model="tempat_domisili.negara"
                    />
                  </b-form-group>
                </b-col>
                <!-- privinsi -->
                <b-col sm="6">
                  <b-form-group
                    lass="text-capitalize pos-relative"
                    :state="getDataError({ rawLabel: 'provinsi domi' })"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'provinsi domi'
                        })
                      })
                    "
                  >
                    <label>Provinsi</label>
                    <vue-select
                      :options="provinces"
                      @input="getCityDomi"
                      :disabled="disabledForm() || alamatDomisiliSesuaiKTP == 1"
                      v-model="tempat_domisili.provinsi"
                    />
                  </b-form-group>
                </b-col>
                <!-- kota -->
                <b-col sm="6">
                  <b-form-group
                    class="text-capitalize pos-relative"
                    :state="getDataError({ rawLabel: 'kota domi' })"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'kota domi'
                        })
                      })
                    "
                  >
                    <label>Kotamadya / Kabupaten</label>
                    <vue-select
                      :options="cities_domi"
                      v-model="tempat_domisili.kota"
                      @input="setDataTempatDomi"
                      :disabled="disabledForm() || alamatDomisiliSesuaiKTP == 1"
                    />
                  </b-form-group>
                </b-col>
                <!-- kecamatan -->
                <b-col sm="6">
                  <b-form-group
                    class="text-capitalize pos-relative"
                    :state="getDataError({ rawLabel: 'kecamatan domi' })"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'kecamatan domi'
                        })
                      })
                    "
                  >
                    <label>Kecamatan</label>
                    <vue-select
                      :options="kecamatanOption_domi"
                      v-model="tempat_domisili.kecamatan"
                      @input="setDataTempatKecamatanDomi"
                      :disabled="disabledForm() || alamatDomisiliSesuaiKTP == 1"
                    />
                  </b-form-group>
                </b-col>
                <!-- desa -->
                <b-col sm="6">
                  <b-form-group
                    class="text-capitalize pos-relative"
                    :state="getDataError({ rawLabel: 'kelurahan domi' })"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'kelurahan domi'
                        })
                      })
                    "
                  >
                    <label>Kelurahan / Desa</label>
                    <vue-select
                      :options="kelurahanOption_domi"
                      v-model="tempat_domisili.kelurahan"
                      @input="setDataTempatKelurahanDomi"
                      :disabled="disabledForm() || alamatDomisiliSesuaiKTP == 1"
                    />
                  </b-form-group>
                </b-col>
                <!-- kode pos -->
                <b-col sm="6">
                  <b-form-group
                    :label="renderLabel({ label: 'kode pos' })"
                    class="text-capitalize pos-relative"
                    :state="getDataError({ rawLabel: 'kode pos domisili' })"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'kode pos domisili'
                        })
                      })
                    "
                  >
                    <b-form-input
                      @keypress="
                        onKeyInputNumber({
                          rawLabel: 'kode pos domisili',
                          $event
                        })
                      "
                      @keyup="
                        setValue({
                          rawLabel: 'kode pos domisili',
                          $event
                        })
                      "
                      :disabled="disabledForm() || alamatDomisiliSesuaiKTP == 1"
                      :value="getValue('kode pos domisili')"
                    />
                  </b-form-group>
                </b-col>
                <!-- alamat rumah -->
                <b-col sm="6">
                  <b-form-group
                    class="text-capitalize pos-relative"                    
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'alamat lengkap domisili'
                        })
                      })
                    "
                  >
                    <label for="">{{
                      renderLabel({ label: "alamat lengkap" })
                    }}</label>
                    <b-form-textarea
                      @keyup="
                        setValue({
                          rawLabel: 'alamat lengkap domisili',
                          $event
                        })
                      "
                      id="alamat_lengkap_domi"
                      rows="3"
                      ref="alamat_domi"
                    
                      :disabled="disabledForm() || alamatDomisiliSesuaiKTP == 1"
                      :value="getValue('alamat lengkap domisili')"
                      :maxlength="100"
                    />
                  </b-form-group>
                </b-col>
                <!-- rt -->
                <b-col sm="6" lg="3">
                  <b-form-group
                    :label="renderLabel({ label: 'Rukun Tetangga /RT' })"
                    class="text-capitalize pos-relative"
                    :state="getDataError({ rawLabel: 'rt domisili' })"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'rt domisili'
                        })
                      })
                    "
                  >
                    <b-form-input
                      @keypress="
                        onKeyInputNumber({
                          rawLabel: 'rt domisili',
                          $event
                        })
                      "
                      @keyup="
                        setValue({
                          rawLabel: 'rt domisili',
                          $event
                        })
                      "
                      :disabled="disabledForm() || alamatDomisiliSesuaiKTP == 1"
                      :value="getValue('rt domisili')"
                      :maxlength="3"
                    />
                  </b-form-group>
                </b-col>
                <!-- rw -->
                <b-col sm="6" lg="3">
                  <b-form-group
                    :label="renderLabel({ label: 'Rukun Warga /RW' })"
                    class="text-capitalize pos-relative"
                    :state="getDataError({ rawLabel: 'rw domisili' })"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'rw domisili'
                        })
                      })
                    "
                  >
                    <b-form-input
                      @keypress="
                        onKeyInputNumber({
                          rawLabel: 'rw domisili',
                          $event
                        })
                      "
                      @keyup="
                        setValue({
                          rawLabel: 'rw domisili',
                          $event
                        })
                      "
                      :disabled="disabledForm() || alamatDomisiliSesuaiKTP == 1"
                      :value="getValue('rw domisili')"
                      :maxlength="3"
                    />
                  </b-form-group>
                </b-col>
              </div>
            </b-collapse>
          </div>
          <div class="emergency-contact">
            <div
              class="row pointer"
              @click="visible_section_4 = !visible_section_4"
            >
              <div class="col-md font-weight-bold">
                KONTAK DARURAT
              </div>
              <div class="col-md text-right">
                <font-awesome-icon
                  class="fs-24"
                  :icon="['fas', 'chevron-down']"
                  :class="{
                    'rotate-0': visible_section_4,
                    'rotate-90': !visible_section_4
                  }"
                />
              </div>
            </div>
            <hr />
            <b-collapse
              id="accordion-4"
              v-model="visible_section_4"
              accordion="my-accordion"
              role="tabpanel"
            >
              <div class="row mb-4">
                <!-- nama penanggung jawab -->
                <b-col sm="6">
                  <b-form-group
                    :label="renderLabel({ label: 'nama penanggung jawab' })"
                    class="text-capitalize pos-relative"
                    :state="getDataError({ rawLabel: 'nama penanggung jawab' })"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'nama penanggung jawab'
                        })
                      })
                    "
                  >
                    <b-form-input
                      @keyup="
                        setValue({
                          rawLabel: 'nama penanggung jawab',
                          $event
                        })
                      "
                      :disabled="disabledForm()"
                      :value="getValue('nama penanggung jawab')"
                      :maxlength="30"
                    />
                  </b-form-group>
                </b-col>
                <!-- no hp penanggung jawab -->
                <b-col sm="6">
                  <b-form-group
                    :label="renderLabel({ label: 'no. hp penanggung jawab' })"
                    class="text-capitalize pos-relative"
                    :state="
                      getDataError({ rawLabel: 'no. hp penanggung jawab' })
                    "
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'no. hp penanggung jawab'
                        })
                      })
                    "
                  >
                    <b-form-input
                      @keypress="
                        onKeyInputNumber({
                          rawLabel: 'no. hp penanggung jawab',
                          $event
                        })
                      "
                      @keyup="
                        setValue({
                          rawLabel: 'no. hp penanggung jawab',
                          $event
                        })
                      "
                      :disabled="disabledForm()"
                      :value="getValue('no. hp penanggung jawab')"
                      :maxlength="15"
                    />
                  </b-form-group>
                </b-col>
                <!-- hubungan dengan pasien -->
                <b-col sm="6">
                  <b-form-group
                    :label="renderLabel({ label: 'hubungan dengan pasien' })"
                    class="text-capitalize pos-relative"
                  >
                    <vue-select
                      :options="[
                        'Suami/Istri',
                        'Orangtua',
                        'Kakak/Adik',
                        'Anak',
                        'Lainnya'
                      ]"
                      @input="
                        setValue({
                          rawLabel: 'hubungan pasien',
                          $event
                        })
                      "
                      :disabled="disabledForm()"
                      :value="getValue('hubungan pasien')"
                    />
                  </b-form-group>
                </b-col>
              </div>
            </b-collapse>
          </div>
          <div class="patient-information">
            <div
              class="row pointer"
              @click="visible_section_5 = !visible_section_5"
            >
              <div class="col-md font-weight-bold">
                INFORMASI PASIEN
              </div>
              <div class="col-md text-right">
                <font-awesome-icon
                  class="fs-24"
                  :icon="['fas', 'chevron-down']"
                  :class="{
                    'rotate-0': visible_section_5,
                    'rotate-90': !visible_section_5
                  }"
                />
              </div>
            </div>
            <hr />
            <b-collapse
              id="accordion-5"
              v-model="visible_section_5"
              accordion="my-accordion"
              role="tabpanel"
            >
              <div class="row mb-4">
                <div class="col">
                  <label class="">Tinggi Badan (cm)</label>
                  <b-form-input
                    :maxlength="5"
                    @keyup="
                      setValue({
                        rawLabel: 'tinggi badan',
                        $event
                      })
                    "
                    @keydown.native="
                      onKeyInputNumberSpecial({
                        rawLabel: 'tinggi badan',
                        $event
                      })
                    "
                    :disabled="disabledForm()"
                    :value="
                      getValue('tinggi badan') ? getValue('tinggi badan') : null
                    "
                  />
                </div>
                <div class="col">
                  <label class="">Berat Badan (kg)</label>
                  <b-form-input
                    :maxlength="5"
                    @keydown.native="
                      onKeyInputNumberSpecial({
                        rawLabel: 'berat badan',
                        $event
                      })
                    "
                    @keyup="
                      setValue({
                        rawLabel: 'berat badan',
                        $event
                      })
                    "
                    :disabled="disabledForm()"
                    :value="
                      getValue('berat badan') ? getValue('berat badan') : null
                    "
                  />
                </div>
              </div>
            </b-collapse>
          </div>
          <div class="alergi-kondisi-khusus" :class="{'section-error': section6Error }">
            <div
              class="row pointer"
              @click="visible_section_6 = !visible_section_6"
            >
              <div class="col-md font-weight-bold">
                Alergi & Kondisi Khusus
              </div>
              <div class="col-md text-right">
                <font-awesome-icon
                  class="fs-24"
                  :icon="['fas', 'chevron-down']"
                  :class="{
                    'rotate-0': visible_section_6,
                    'rotate-90': !visible_section_6
                  }"
                />
              </div>
            </div>
            <hr />
            <b-collapse
              id="accordion-6"
              v-model="visible_section_6"
              accordion="my-accordion"
              role="tabpanel"
            >
              <div class="row">
                <!-- riwayat penyakit -->
                <b-col sm="3">
                  <b-form-group
                    :label="renderLabel({ label: 'riwayat penyakit' })"
                    class="text-capitalize pos-relative"
                    :state="getDataError({ rawLabel: 'riwayat penyakit' })"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'riwayat penyakit'
                        })
                      })
                    "
                  >
                    <b-form-input
                      @keyup="
                        setValue({
                          rawLabel: 'riwayat penyakit',
                          $event
                        })
                      "
                      :disabled="disabledForm()"
                      :value="getValue('riwayat penyakit')"
                    />
                  </b-form-group>
                </b-col>
                <!-- riwayat alergi obat -->
                <b-col sm="3">
                  <b-form-group
                    :label="renderLabel({ label: 'riwayat alergi obat' })"
                    class="text-capitalize pos-relative"
                    :state="getDataError({ rawLabel: 'riwayat alergi obat' })"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'riwayat alergi obat'
                        })
                      })
                    "
                  >
                    <vue-select
                      :options="optAlergiObat"
                      @input="
                        setValue({
                          rawLabel: 'riwayat alergi obat',
                          $event
                        })
                      "
                      :disabled="disabledForm()"
                      :value="getValue('riwayat alergi obat')"
                      v-if="pcareVersion == '1'"
                    />
                    <b-form-input
                      @keyup="
                        setValue({
                          rawLabel: 'riwayat alergi obat',
                          $event
                        })
                      "
                      :disabled="disabledForm()"
                      :value="getValue('riwayat alergi obat')"
                      v-else
                    />
                  </b-form-group>
                </b-col>
                <b-col sm="3" v-if="checkLain('obat')">
                  <br>
                  <b-form-input
                    ref="ket_riwayat_alergi_obat"
                    type="text"
                    v-model.lazy="formData['ket_riwayat_alergi_obat']"
                    class="mt-2"
                    :disabled="disabledForm()"
                    @keyup="
                      setValue({
                        rawLabel: 'ket riwayat alergi obat',
                        $event
                      })
                    "
                  />
                  <b-form-invalid-feedback
                    :state="renderError({ error:
                      alergi.ket_obat_lain &&
                      (!formData['ket_riwayat_alergi_obat'] || formData['ket_riwayat_alergi_obat'] == '')
                    })"
                  >wajib diisi</b-form-invalid-feedback>
                </b-col>
                <!-- riwayat alergi makanan -->
                <b-col sm="3">
                  <b-form-group
                    :label="renderLabel({ label: 'riwayat alergi makanan' })"
                    class="text-capitalize pos-relative"
                    :state="
                      getDataError({ rawLabel: 'riwayat alergi makanan' })
                    "
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'riwayat alergi makanan'
                        })
                      })
                    "
                  >
                    <vue-select
                      :options="optAlergiMakanan"
                      @input="
                        setValue({
                          rawLabel: 'riwayat alergi makanan',
                          $event
                        })
                      "
                      :disabled="disabledForm()"
                      :value="getValue('riwayat alergi makanan')"
                      v-if="pcareVersion == '1'"
                    />
                    <b-form-input
                      @keyup="
                        setValue({
                          rawLabel: 'riwayat alergi makanan',
                          $event
                        })
                      "
                      :disabled="disabledForm()"
                      :value="getValue('riwayat alergi makanan')"
                      v-else
                    />
                  </b-form-group>
                </b-col>
                <b-col sm="3" v-if="checkLain('makanan')">
                  <br>
                  <b-form-input
                    ref="ket_riwayat_alergi_makanan"
                    type="text"
                    v-model.lazy="formData['ket_riwayat_alergi_makanan']"
                    class="mt-2"
                    :disabled="disabledForm()"
                    @keyup="
                      setValue({
                        rawLabel: 'ket riwayat alergi makanan',
                        $event
                      })
                    "
                  />
                  <b-form-invalid-feedback
                    :state="renderError({ error:
                      alergi.ket_makanan_lain &&
                      (!formData['ket_riwayat_alergi_makanan'] || formData['ket_riwayat_alergi_makanan'] == '')
                    })"
                  >wajib diisi</b-form-invalid-feedback>
                </b-col>
                <!-- riwayat alergi udara -->
                <b-col sm="3">
                  <b-form-group
                    :label="renderLabel({ label: 'riwayat alergi udara' })"
                    class="text-capitalize pos-relative"
                    :state="getDataError({ rawLabel: 'riwayat alergi udara' })"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'riwayat alergi udara'
                        })
                      })
                    "
                  >
                    <vue-select
                      :options="optAlergiUdara"
                      @input="
                        setValue({
                          rawLabel: 'riwayat alergi udara',
                          $event
                        })
                      "
                      :disabled="disabledForm()"
                      :value="getValue('riwayat alergi udara')"
                      v-if="pcareVersion == '1'"
                    />
                    <b-form-input
                      @keyup="
                        setValue({
                          rawLabel: 'riwayat alergi udara',
                          $event
                        })
                      "
                      :disabled="disabledForm()"
                      :value="getValue('riwayat alergi udara')"
                      v-else
                    />
                  </b-form-group>
                </b-col>
                <!-- riwayat alergi lain -->
                <b-col sm="3">
                  <b-form-group
                    :label="renderLabel({ label: 'riwayat alergi lain-lain' })"
                    class="text-capitalize pos-relative"
                    :state="getDataError({ rawLabel: 'riwayat alergi lain' })"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'riwayat alergi lain'
                        })
                      })
                    "
                  >
                    <b-form-input
                      @keyup="
                        setValue({
                          rawLabel: 'riwayat alergi lain',
                          $event
                        })
                      "
                      :disabled="disabledForm()"
                      :value="getValue('riwayat alergi lain')"
                    />
                  </b-form-group>
                </b-col>
                <!-- riwayat pengobatan -->
                <b-col sm="3">
                  <b-form-group
                    :label="renderLabel({ label: 'riwayat pengobatan' })"
                    class="text-capitalize pos-relative"
                    :state="getDataError({ rawLabel: 'riwayat pengobatan' })"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: blindlyGetData({
                          rawLabel: 'riwayat pengobatan'
                        })
                      })
                    "
                  >
                    <b-form-input
                      @keyup="
                        setValue({
                          rawLabel: 'riwayat pengobatan',
                          $event
                        })
                      "
                      :disabled="disabledForm()"
                      :value="getValue('riwayat pengobatan')"
                    />
                  </b-form-group>
                </b-col>
                <!-- keterangan lain -->
                <b-col sm="12">
                  <b-form-group
                    class="text-capitalize pos-relative"
                  >
                    <label for="">{{
                      renderLabel({ label: "keterangan lain" })
                    }}</label>
                    <b-form-textarea
                      @keyup="
                        setValue({
                          rawLabel: 'keterangan lain',
                          $event
                        })
                      "
                      rows="3"
                      :disabled="disabledForm()"
                      :value="getValue('keterangan lain')"
                    />
                  </b-form-group>
                </b-col>
              </div>
            </b-collapse>
          </div>
        </div>
        <b-row>
          <b-col sm="6">
            <div v-show="satusehatAuthValid && formType === 'edit'">
              <div class="sync-satusehat">
                Sync dengan SatuSehat
                <span class="ml-2">
                  <font-awesome-icon
                    v-if="synced"
                    :icon="['fas', 'check-circle']"
                    class="fs-27 fc-synced"
                  />
                  <font-awesome-layers v-else class="fs-27">
                    <font-awesome-icon
                      :icon="['far', 'circle']"
                      class="op-3"
                    />
                    <font-awesome-icon
                      :icon="['fas', 'sync']"
                      transform="shrink-8"
                      class="fc-sync c-default"
                      spin
                      v-if="syncing"
                    />
                    <font-awesome-icon
                      v-else
                      @click="syncHandler"
                      :icon="['fas', 'sync']"
                      transform="shrink-8"
                      class="fc-sync pointer"
                    />
                  </font-awesome-layers>
                </span>
              </div>
            </div>
            <div v-show="satusehatAuthValid && formType === 'detail' && synced">
              <div class="sync-satusehat">
                Sync dengan SatuSehat
                <span class="ml-2">
                  <font-awesome-icon
                    v-if="synced"
                    :icon="['fas', 'check-circle']"
                    class="fs-27 fc-synced"
                  />
                </span>
              </div>
            </div>
          </b-col>
          <!-- is antrean -->
          <b-col sm="6">
            <template v-if="formType !== 'detail' && formType !== 'edit'">
              <b-form-group class="text-capitalize pos-relative">
                <p class="mb-1 flex-grow-1">
                  Masukkan Pasien ke Antrean?
                  <toggle-button
                    v-model="isAntrean"
                    :labels="{ checked: 'Ya', unchecked: 'Tidak' }"
                    :width="65"
                    :color="{
                      checked: '#3c44b1',
                      unchecked: '#f83245',
                      disabled: '#CCCCCC'
                    }"
                    class="float-right"
                  />
                </p>
              </b-form-group>
            </template>
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col sm="6"></b-col>
          <!-- button -->
          <b-col sm="6">
            <template v-if="formType !== 'detail'">
              <b-button
                class="ml-3 text-uppercase float-right fs-17-5"
                variant="primary"
                @click="submitForm"
                >simpan
              </b-button>
              <b-button
                :to="{ name: 'pasien-klinik-list' }"
                class="text-uppercase float-right fs-17-5"
                :variant="btnVariant()"
                >{{ btnText() }}</b-button
              >
            </template>
            <template v-else>
              <b-button
                :to="{ name: 'pasien-klinik-list' }"
                class="text-uppercase float-right fs-17-5"
                :variant="btnVariant()"
                >{{ btnText() }}</b-button
              >
              <b-button
                class="mr-4 text-uppercase float-right fs-17-5"
                variant="success"
                v-if="hasFeatures('edit_patient')"
                @click="
                  $router.push({
                    name: 'pasien-klinik-edit',
                    params: { idPasien },
                    query: {
                      klinik_id: $route.query.klinik_id
                    }
                  })
                "
                >edit</b-button
              >
            </template>
          </b-col>
        </b-row>
      </b-container>
    </b-form>
  </div>
</template>

<script>
import Vue from "vue";

import { mapGetters } from "vuex";
import startCase from "lodash/startCase";
import ImageUploader from "vue-image-upload-resize";
import { ToggleButton } from "vue-js-toggle-button";
Vue.use(ImageUploader);
import { required, requiredIf, minLength, numeric, email } from "vuelidate/lib/validators";
import "vue-datetime/dist/vue-datetime.css";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import moment from "moment";
moment.locale("id");
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCamera,
  faCaretDown,
  faCalendar,
  faClipboardList,
  faChevronDown,
  faSync,
  faCheckCircle
} from "@fortawesome/free-solid-svg-icons";
import { faCircle as farCircle } from "@fortawesome/free-regular-svg-icons";
import noTelponAllCountry from "./no_telpon.json";

library.add(
  faClipboardList,
  faCamera,
  faCaretDown,
  faCalendar,
  faChevronDown,
  faSync,
  farCircle,
  faCheckCircle
);

let tmp = [
  {
    label: "No. RM Manual",
    alias: "nomor_rekam_medis_manual",
    error: false,
    validations: {}
  },
  {
    label: "nama lengkap",
    alias: "nama",
    validations: {
      required
    }
  },
  {
    label: "no. handphone",
    alias: "nomor_hp",
    validations: {
      required,
      numeric,
      minLength: minLength(8)
    }
  },
  {
    label: "nik",
    alias: "nik",
    validations: {}
  },
  {
    label: "email",
    alias: "email",
    error: false,
    validations: {
      email
    }
  },
  {
    label: "tanggal lahir",
    alias: "tanggal_lahir",
    validations: {
      required
    }
  },
  {
    label: "jenis kelamin",
    alias: "jenis_kelamin",
    validations: {
      required
    }
  },
  {
    label: "gol. darah",
    alias: "golongan_darah",
    error: false,
    validations: {}
  },
  {
    label: "nama penanggung jawab",
    alias: "nama_penanggung_jawab",
    error: false,
    validations: {}
  },
  {
    label: "no. hp penanggung jawab",
    alias: "nomor_hp_penanggung_jawab",
    error: false,
    validations: {
      minLength: minLength(8)
    }
  },
  {
    label: "hubungan pasien",
    alias: "hubungan_pasien",
    error: false,
    validations: {}
  },
  {
    label: "alamat rumah",
    alias: "alamat_rumah",
    validations: {
      required
    }
  },
  {
    label: "status perkawinan",
    alias: "status_perkawinan",
    error: false,
    validations: {}
  },
  {
    label: "jenis identitas",
    alias: "jenis_identitas",
    validations: {
      required: requiredIf(function() {
        let status = (!this.isForgotNik ? true : (this.isForgotNik ? false : this.isLessThan17));
        return status;
      })
    }
  },
  {
    label: "nomor rekam medis",
    alias: "nomor_rekam_medis",
    error: false,
    validations: {}
  },
  {
    label: "provinsi",
    alias: "provinsi",
    error: false,
    validations: {}
  },
  {
    label: "kota",
    alias: "kota",
    error: false,
    validations: {}
  },
  {
    label: "tinggi badan",
    alias: "tinggi_badan",
    error: false,
    validations: {}
  },
  {
    label: "berat badan",
    alias: "berat_badan",
    error: false,
    validations: {}
  },
  {
    label: "alergi kondisi khusus",
    alias: "alergi_kondisi_khusus",
    error: false,
    validations: {}
  },
  {
    label: "keterangan lain",
    alias: "keterangan_lain",
    error: false,
    validations: {}
  },
  {
    label: "tempat lahir",
    alias: "tempat_lahir",
    validations: {
      required
    }
  },
  {
    label: "no. KTP ibu kandung",
    alias: "no._KTP_ibu_kandung",
    validations: {
      required: requiredIf(function() {
        return this.isLessThan17
      })
    }
  },
  {
    label: "nama ibu kandung",
    alias: "nama_ibu_kandung",
    error: false,
    validations: {}
  },
  {
    label: "agama",
    alias: "agama",
    error: false,
    validations: {}
  },
  {
    label: "suku",
    alias: "suku",
    error: false,
    validations: {}
  },
  {
    label: "bahasa yang dikuasai",
    alias: "bahasa_yang_dikuasai",
    error: false,
    validations: {}
  },
  {
    label: "negara",
    alias: "negara",
    error: false,
    validations: {}
  },
  {
    label: "kecamatan",
    alias: "kecamatan",
    error: false,
    validations: {}
  },
  {
    label: "kelurahan",
    alias: "kelurahan",
    error: false,
    validations: {}
  },
  {
    label: "kode pos",
    alias: "kode_pos",
    error: false,
    validations: {
      numeric
    }
  },
  {
    label: "alamat lengkap domisili",
    alias: "alamat_lengkap_domisili",
    error: false,
    validations: {}
  },
  {
    label: "rt",
    alias: "rt",
    error: false,
    validations: {}
  },
  {
    label: "rw",
    alias: "rw",
    error: false,
    validations: {}
  },
  {
    label: "negara domi",
    alias: "negara_domi",
    error: false,
    validations: {}
  },
  {
    label: "kecamatan domi",
    alias: "kecamatan_domi",
    error: false,
    validations: {}
  },
  {
    label: "kelurahan domi",
    alias: "kelurahan_domi",
    error: false,
    validations: {}
  },
  {
    label: "kode pos domisili",
    alias: "kode_pos_domisili",
    error: false,
    validations: {
      numeric
    }
  },
  {
    label: "rt domisili",
    alias: "rt_domisili",
    error: false,
    validations: {}
  },
  {
    label: "rw domisili",
    alias: "rw_domisili",
    error: false,
    validations: {}
  },
  {
    label: "riwayat penyakit",
    alias: "riwayat_penyakit",
    error: false,
    validations: {}
  },
  {
    label: "riwayat alergi obat",
    alias: "riwayat_alergi_obat",
    error: false,
    validations: {}
  },
  {
    label: "ket riwayat alergi obat",
    alias: "ket_riwayat_alergi_obat",
    error: false,
    validations: {}
  },
  {
    label: "riwayat alergi makanan",
    alias: "riwayat_alergi_makanan",
    error: false,
    validations: {}
  },
  {
    label: "ket riwayat alergi makanan",
    alias: "ket_riwayat_alergi_makanan",
    error: false,
    validations: {}
  },
  {
    label: "riwayat alergi udara",
    alias: "riwayat_alergi_udara",
    error: false,
    validations: {}
  },
  {
    label: "riwayat alergi lain",
    alias: "riwayat_alergi_lain",
    error: false,
    validations: {}
  },
  {
    label: "riwayat pengobatan",
    alias: "riwayat_pengobatan",
    error: false,
    validations: {}
  },
  {
    label: "paspor",
    alias: "paspor",
    validations: {
      minLength: minLength(10)
    }
  },
  {
    label: "kitas",
    alias: "kitas",
    validations: {
      minLength: minLength(11)
    }
  }
];
moment.locale("id");
export default {
  components: {
    "vue-select": () => import("@/components/VueSelectClearable.vue"),
    DatePickerX: () => import("v-calendar/lib/components/date-picker.umd"),
    "toggle-button": ToggleButton
  },
  props: {
    formType: {
      default: "add",
      type: String
    },
    idPasien: {
      type: [String, Number]
    }
  },
  data: () => ({
    section1Error: false,
    section2Error: false,
    section6Error: false,
    satusehat_patient_id: null,
    maxlengthNik: 16,
    noIdentitasTouch: false,
    noIdentitasIbuTouch: false,
    noHpType: { value: 62, label: "Indonesia +62" },
    noHpOptions: noTelponAllCountry,
    cek_anggota_bpjs: false,
    jenis_identitas_error_api: false,
    jenis_identitas_ibu_error_api: false,
    syncing: false,
    synced: false,
    alamatDomisiliSesuaiKTP: null,
    visible_section_1: true,
    visible_section_2: false,
    visible_section_3: false,
    visible_section_4: false,
    visible_section_5: false,
    visible_section_6: false,
    beingSubmit: false,
    dataPasien: null,
    formBasicData: null,
    formData: {
      jenis_identitas: null,
      nik: null,
      "no._KTP_ibu_kandung": null,
      tanggal_lahir: null
    },
    selected: null,
    hasImage: false,
    heightFoto: "",
    image: null,
    isAntrean: false,
    selectTempat: null,
    checkValueNik: null,
    countries: [{ label: "Indonesia", id: "1" }],
    provinces: [],
    cities: [],
    kecamatanOption: [],
    kelurahanOption: [],
    provinces_domi: [],
    cities_domi: [],
    kecamatanOption_domi: [],
    kelurahanOption_domi: [],
    tempat: {
      negara: { label: "Indonesia", id: "1" },
      provinsi: null,
      kota: null,
      kecamatan: null,
      kelurahan: null
    },
    nama_touched: false,
    tempat_lahir_touched: false,
    alamat_rumah_touched: false,
    handphone_touched: false,
    negara_touched: false,
    provinsi_touched: false,
    kota_touched: false,
    kecamatan_touched: false,
    kelurahan_touched: false,
    tempat_domisili: {
      negara: { label: "Indonesia", id: "1" },
      provinsi: null,
      kota: null,
      kecamatan: null,
      kelurahan: null
    },
    isBPJS: false,
    pcareVersion: null,
    isEditBPJS: false,
    card_number: {
      number: null,
      error: false,
      message: null
    },
    dataBPJS: null,
    isForgotNik: false,
    isForgotNikFromApi: false,
    isLessThan17: false,
    isFirstLoad: true,
    isEditPasien: false,
    optAlergiMakanan: [],
    optAlergiUdara: [],
    optAlergiObat: [],
    alergi: {
      makanan_lain: false,
      ket_makanan_lain: null,
      obat_lain: false,
      ket_obat_lain: null,
    },
  }),
  watch: {
    "formData.tanggal_lahir": function(val) {
      if (val != "") {
        this.noIdentitasIbuTouch = false;
        this.checkBoDLessThan17(val);
        this.formBasicData[5].error = false;
      }
    },
    tempat: {
      handler: function(val) {},
      deep: true
    },
    "tempat.provinsi": {
      handler: function(newVal, oldVal) {
        if (newVal === oldVal && newVal && oldVal) {
          const { provinsi_name: pnl } = newVal;
          const { provinsi_name: pnb } = oldVal;
          if (pnl.toLowerCase() !== pnb.toLowerCase()) {
            this.provinsi.kota = null;
          }
        }
      },
      deep: true
    },
    isBPJS: {
      handler: function(val) {
        if (!val) {
          this.card_number = {
            number: null,
            error: false,
            message: null
          };
        }
      },
      deep: true
    },
    cek_anggota_bpjs(val) {
      if (val) this.pcareVersion = this.bpjsConfig.pcare_version;
      else this.pcareVersion = null;
    }
  },
  computed: {
    ...mapGetters({
      getRolesName: "getRolesName",
      getKlinikId: "getKlinikId",
      bpjsAuthValid: "bpjsAuthValid",
      satusehatAuthValid: "satusehatAuthValid",
      bpjsConfig: "bpjsConfig",
    }),
    maximumDatetime() {
      return moment().format("YYYY-MM-DD");
    },
    stateNamaLengkap() {
      if(!this.formData['nama_lengkap'] && this.nama_touched) return false;

      return null;
    },
    stateHandphone() {
      if(!this.formData['no._handphone'] && this.handphone_touched) return false;

      return null;
    },
    stateTempatLahir() {
      if(!this.formData["tempat_lahir"] && this.tempat_lahir_touched) return false

      return null;
    },
    stateAlamatLengkap() {
      if(!this.formData['alamat_rumah'] && this.alamat_rumah_touched) return false;

      return null;
    },
    stateNegara() {
      if (!this.negara_touched) {
        return null;
      }

      return !(this.tempat.negara === null);
    },
    stateProvinsi() {
      if (!this.provinsi_touched) {
        return null;
      }

      return !(this.tempat.provinsi === null);
    },
    stateKota() {
      if (!this.kota_touched) {
        return null;
      }

      return !(this.tempat.kota === null);
    },
    stateKecamatan() {
      if (!this.kecamatan_touched) {
        return null;
      }

      return !(this.tempat.kecamatan === null);
    },
    stateKelurahan() {
      if (!this.kelurahan_touched) {
        return null;
      }

      return !(this.tempat.kelurahan === null);
    },
    stateRmManual() {
      if(!this.formData["No._RM_Manual"]) {
        return null
      }

      return null;
    },
    stateEmail() {
      if(!this.formData["email"]) {
        return null
      }
      
      const value = this.formData["email"]

      if(!(this.checkEmailIsValid(value))) {
        return false
      }

      return null;
    },
    stateNoIdentitas() {
      if (!this.noIdentitasTouch) {
        return null;
      }

      if (this.formData["jenis_identitas"] === null ||
        this.formData["jenis_identitas"] === "") {
          return null;
      }

      if (
        (this.formData["jenis_identitas"] === null ||
        this.formData["jenis_identitas"] === "") && !this.isForgotNik
      ) {
        return false;
      }

      if ((this.formData.nik === null || this.formData.nik === "")  && !this.isForgotNik) {
        return false;
      }

      if (
        this.formData["jenis_identitas"] === "KTP" &&
        this.formData.nik.length < 16
      ) {
        return false;
      }

      if (
        this.formData["jenis_identitas"] === "Paspor" &&
        this.formData.nik.length < 10
      ) {
        return false;
      }

      if (
        this.formData["jenis_identitas"] === "KITAS" &&
        this.formData.nik.length < 11
      ) {
        return false;
      }

      if (this.jenis_identitas_error_api) {
        return false;
      }

      return null;
    },
    invalidFeedbackNoIdentitas() {
      if (
        (this.formData["jenis_identitas"] === null ||
        this.formData["jenis_identitas"] === "") && !this.isForgotNik && this.noIdentitasTouch
      ) {
        return "Pilih Jenis Identitas Terlebih Dahulu";
      }

      if ((this.formData.nik === null || this.formData.nik === "") && !this.isForgotNik) {
        return "No Identitas Harus Diisi";
      }

      if (
        this.formData["jenis_identitas"] === "KTP" &&
        this.formData.nik.length < 16
      ) {
        return "No KTP Minimal 16 Angka";
      }

      if (
        this.formData["jenis_identitas"] === "Paspor" &&
        this.formData.nik.length < 10
      ) {
        return "Paspor Minimal 10 Karakter";
      }

      if (
        this.formData["jenis_identitas"] === "KITAS" &&
        this.formData.nik.length < 11
      ) {
        return "KITAS Minimal 11 Karakter";
      }

      if (this.jenis_identitas_error_api) {
        return "No Identitas sudah dipakai";
      }

      return null;
    },
    stateNoIdentitasIbu() {
      if (!this.noIdentitasIbuTouch) {
        return null;
      }

      if (
        (this.formData["no._KTP_ibu_kandung"] === null ||
        this.formData["no._KTP_ibu_kandung"] === "") && this.isLessThan17 && this.noIdentitasIbuTouch
      ) {
        return false;
      }

      if (
        this.formData["no._KTP_ibu_kandung"] && this.formData["no._KTP_ibu_kandung"].length < 16 && this.isLessThan17
      ) {
        return false;
      }

      if (this.jenis_identitas_ibu_error_api && this.isLessThan17) {
        return false;
      }

      return null;
    },
    invalidFeedbackNoIdentitasIbu() {
      if ((this.formData["no._KTP_ibu_kandung"] === null || this.formData["no._KTP_ibu_kandung"] === "") && this.isLessThan17 && this.noIdentitasIbuTouch) {
        return "No. KTP Ibu Kandung Harus Diisi";
      }

      if (
        this.formData["no._KTP_ibu_kandung"] && this.formData["no._KTP_ibu_kandung"].length < 16 && this.isLessThan17
      ) {
        return "No KTP Ibu Kandung Minimal 16 Angka";
      }

      if (this.jenis_identitas_ibu_error_api && this.isLessThan17) {
        return "No KTP Ibu Kandung sudah dipakai";
      }

      return null;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.beingSubmit && localStorage.getItem("IDLE") != 1) {
      this.$swal({
        title: startCase("keluar"),
        html: `Apakah Anda yakin untuk keluar dari halaman ini?<br>Data yang telah ditulis tidak akan tersimpan.`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: startCase("tidak"),
        confirmButtonText: startCase("ya")
      }).then(res => {
        if (res.value) {
          next();
        } else {
          next(false);
        }
      });
    } else {
      next();
    }
  },
  validations() {
    return {
      formData: {
        ...tmp.reduce((obj, item) => {
          obj[item.label.split(" ").join("_")] = item.validations;
          return obj;
        }, {})
      }
    };
  },
  async mounted() {
    if (this.bpjsAuthValid) {
      this.isBPJS = true;
      if (this.bpjsConfig.pcare_version == '1') {
        this.optAlergiMakanan = await this.fetchAlergiJenis('01');
        this.optAlergiUdara = await this.fetchAlergiJenis('02');
        this.optAlergiObat = await this.fetchAlergiJenis('03');
      }
    }
    this.formBasicData = this.setFormBasicData();
    this.formData = this.setFormData();
    this.getProvince();
    if (this.$router.currentRoute.params.idPasien) {
      this.isEditPasien = true;
      await this.getPasienData(this.$router.currentRoute.params.idPasien);
    }
    this.isAntrean = localStorage.getItem("is_antrean") ? true : false;
    this.isForgotNik = this.isForgotNikFromApi == 1 || this.isLessThan17 ? true : false;
  },
  methods: {
    checkEmailIsValid(val) {
      return val.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    },
    checkBoDLessThan17 (val) {

      this.isFirstLoad = false;
      const toggleStatus = this.isForgotNik
      if(moment().diff(val, 'years') < 17) {
          this.isLessThan17 = true;
          this.isForgotNik = true;
          this.switchForgotNik(true);
        } else {
          this.isLessThan17 = false;
          this.isForgotNik = false;
          this.switchForgotNik(toggleStatus);
        }
    },
    switchForgotNik(value) {
      this.isFirstLoad = false;
      this.isForgotNik = value;

      this.noIdentitasTouch = false;

      if(this.isForgotNik && !this.$router.currentRoute.params.idPasien) {
        this.setValue({
          rawLabel: "nik",
          $event: null
        });

        this.setValue({
          rawLabel: "jenis identitas",
          $event: null
        });

        this.noIdentitasTouch = true;
      }
    },
    onInputNegara() {
      this.negara_touched = true;
      this.duplicateKtpDomisili();
    },
    getPhonePrefix(code) {
      if (code) {
        noTelponAllCountry.map(item => {
          if (item.value == code) {
            this.noHpType = item;
          }
        });
      }
    },
    filterInputNoIdentitas(event) {
      if (this.formData["jenis_identitas"] === "KTP" || this.isLessThan17) {
        this.onKeyInputNumberSpecial(event);
      } else {
        this.onKeyInputPreventSymbol(event);
      }
    },
    onInputNik() {
      this.synced = false;
      this.satusehat_patient_id = null;
      this.jenis_identitas_error_api = false;
      this.noIdentitasTouch = true;
      this.checkNIK();
    },
    onInputNikIbu() {
      this.synced = false;
      this.noIdentitasIbuTouch = false;
      this.satusehat_patient_id = null;
      this.jenis_identitas_ibu_error_api = false;
      this.noIdentitasIbuTouch = true;
      this.checkNIKIbu();
    },
    onInputChangeNoType() {
      if (this.noHpType === null) {
        this.noHpType = this.noHpOptions[72];
      }
    },
    onInputJenisIdentitas() {
      this.formData.nik = "";
      if (this.formData["jenis_identitas"] === "KTP") this.maxlengthNik = 16;
      if (this.formData["jenis_identitas"] === "Paspor") this.maxlengthNik = 10;
      if (this.formData["jenis_identitas"] === "KITAS") this.maxlengthNik = 11;
    },
    syncHandler() {
      if (!this.syncing) {
        this.syncing = true;
        this.syncPatientSatusehat();
      }
    },
    async syncPatientSatusehat() {
      try {
        let syncPF2 = this.formData["jenis_identitas"] == "KTP" && this.formData["nik"];
        let syncPF3 = this.isLessThan17 && (this.formData["no._KTP_ibu_kandung"]);
        let syncPF5 = this.formData["nama_lengkap"] && this.formData['tanggal_lahir'] && this.formData['jenis_kelamin'];

        let params = {};
        let errorMessage = "";

        let patientPromises = []

        if (syncPF2) {
            params = {
                pasien_id: this.$router.currentRoute.params.idPasien,
                klinik_id: this.getKlinikId,
                searchBy: 'PF2',
                nik: this.formData["nik"]
            };
            errorMessage = "NIK tidak ditemukan"

            const byNik = this.$axios.post(
              `satu-sehat/patient/sync`, params
            );
            patientPromises.push(byNik);
        } 
        
        if (syncPF3) {
            params = {
                pasien_id: this.$router.currentRoute.params.idPasien,
                klinik_id: this.getKlinikId,
                searchBy: 'PF3',
                nikIbu: this.formData["no._KTP_ibu_kandung"]
            };
            errorMessage = "NIK Ibu Kandung tidak ditemukan"

            const byNikIbu = this.$axios.post(
              `satu-sehat/patient/sync`, params
            );
            patientPromises.push(byNikIbu);
        }
        
        if (syncPF5) {
            params = {
                pasien_id: this.$router.currentRoute.params.idPasien,
                klinik_id: this.getKlinikId,
                searchBy: 'PF5',
                name: this.formData['nama_lengkap'],
                birthDate: moment(this.formData['tanggal_lahir']).format('YYYY-MM-DD'),
                gender: this.formData['jenis_kelamin'] == 'Laki-laki' ? 'male' : 'female'
            };

            errorMessage = "Nama Lengkap, Jenis Kelamin, dan Tanggal Lahir tidak ditemukan"

            const byBodAndGender = this.$axios.post(
              `satu-sehat/patient/sync`, params
            );
            patientPromises.push(byBodAndGender);
        }

        Promise.all(patientPromises)
          .then((response) => {
            let isPatientExist = false
            for (const result of response) {
              if(result.data.status) {
                isPatientExist = true;
                this.satusehat_patient_id = result.data.satusehat_patient_id;
              } 
            }

            if(!isPatientExist) {
                this.$swal({
                  text: 'Data tidak ditemukan',
                  type: "error"
                });

                return;
              } else {
                this.synced = true;
              }
          })
          .catch((error) => {
            this.$swal({
              text: error.response.data || 'An error occurred',
              type: "error"
            });
          })
      } catch (error) {
        this.$swal({
          text: error.message || 'An error occurred',
          type: "error"
        });
      } finally {
        this.syncing = false;
      }
    },
    onClickCheckboxDomi() {
      this.duplicateKtpDomisili();
      this.duplicateKtpDomisiliInputField();
    },
    duplicateKtpDomisiliInputField() {
      if (this.alamatDomisiliSesuaiKTP == "1" && this.visible_section_2) {
        this.formData["kode_pos_domisili"] = this.formData["kode_pos"];
        this.formData["alamat_lengkap_domisili"] = this.formData[
          "alamat_rumah"
        ];
        this.formData["rt_domisili"] = this.formData["rt"];
        this.formData["rw_domisili"] = this.formData["rw"];
      }
    },
    duplicateKtpDomisili() {
      if (this.alamatDomisiliSesuaiKTP == "1" && this.visible_section_2) {
        this.cities_domi = this.cities;
        this.kecamatanOption = this.kecamatanOption_domi;
        this.kelurahanOptionOption = this.kelurahanOptionOption_domi;

        this.tempat_domisili.negara = this.tempat.negara;
        this.tempat_domisili.provinsi = this.tempat.provinsi;
        this.tempat_domisili.kota = this.tempat.kota;
        this.tempat_domisili.kecamatan = this.tempat.kecamatan;
        this.tempat_domisili.kelurahan = this.tempat.kelurahan;
        this.setDataTempatKelurahanDomi();
      }
    },
    hasFeatures(value) {
      const features = {
        edit_patient: ["pic_cabang", "frontdesk", "kasir"]
      };

      const isOwner = features[value].filter(feature => {
        return this.getRolesName.includes(feature);
      });
      return isOwner.length > 0 ? true : false;
    },
    triggerDob() {
      const x = this.$refs.dob;
      const {
        $el: { firstElementChild }
      } = x;
      firstElementChild && firstElementChild.click();
    },
    getProvince() {
      this.$axios
        .get(`province`)
        .then(response => {
          // handle success
          this.provinces = response.data.data.provinsi.map(val => ({
            ...val,
            label: `${val.provinsi_nama}`
          }));
        })
        .catch(error => {});
    },
    checkNIK() {
      if (
        this.formData["jenis_identitas"] == null ||
        this.formData["jenis_identitas"] == ""
      ) {
        return;
      }
      if (
        (this.formData["jenis_identitas"] == "KTP") &
        (this.formData["nik"] == "" ||
          this.formData["nik"] == null ||
          this.formData["nik"].length < 16)
      ) {
        return;
      }
      if (
        (this.formData["jenis_identitas"] == "Paspor") &
        (this.formData["paspor"] == "" ||
          this.formData["paspor"] == null ||
          this.formData["paspor"].length < 10)
      ) {
        return;
      }
      if (
        (this.formData["jenis_identitas"] == "KITAS") &
        (this.formData["kitas"] == "" ||
          this.formData["kitas"] == null ||
          this.formData["kitas"].length < 11)
      ) {
        return;
      }
      clearTimeout(this.timeVerifyNIK);
      this.timeVerifyNIK = setTimeout(async () => {
        const res = await this.$axios.get(
          `identity/verify?jenis_pengenal=${
            this.formData["jenis_identitas"]
          }&nik=${this.formData["nik"] ||
            this.formData["paspor"] ||
            this.formData["kitas"]}`
        );
        if (res.data.status == false) {
          this.jenis_identitas_error_api = true;
        } else {
          this.jenis_identitas_error_api = false;
        }
      }, 550);
    },
    checkNIKIbu() {
      if (
        this.formData["no._KTP_ibu_kandung"] == null ||
        this.formData["no._KTP_ibu_kandung"] == ""
      ) {
        return;
      }
      if (
        (this.formData["no._KTP_ibu_kandung"].length < 16)
      ) {
        return;
      }
    },
    async getCity() {
      this.provinsi_touched = true;
      this.duplicateKtpDomisili();
      this.tempat.kota = null;
      this.tempat.kecamatan = null;
      this.tempat.kelurahan = null;
      this.cities = [];
      this.kelurahanOption = [];
      this.kecamatanOption = [];
      try {
        var val;
        if (this.tempat.provinsi == "" || this.tempat.provinsi == null) {
          val = "";
        } else {
          val = this.tempat.provinsi.id;
          const res = await this.$axios.get(
            `getcitybyprovince/${val}`
          );
          // handle success
          this.cities = res.data.data.kota.map(val => ({
            ...val,
            label: `${val.nama}`
          }));
        }
        if (this.$router.currentRoute.params.idPasien) {
          if (this.formType == "edit") {
            if (this.tempat.kota.provinsi_id !== this.tempat.provinsi.id) {
              this.tempat.kota = null;
            }
          }
        } else if (this.cities[0].provinsi_id !== this.tempat.provinsi) {
          this.tempat.kota = null;
        }
      } catch (error) {}
    },
    async getKecamatan() {
      this.duplicateKtpDomisili();
      this.tempat.kecamatan = null;
      this.tempat.kelurahan = null;
      this.kelurahanOption = [];
      this.kecamatanOption = [];
      try {
        var val;
        if (this.tempat.kota == "" || this.tempat.kota == null) {
          val = "";
        } else {
          val = this.tempat.kota.id;
          const res = await this.$axios.get(
            `wilayah/kecamatan?kota_id=${val}`
          );
          // handle success
          this.kecamatanOption = res.data.data.map(val => ({
            ...val,
            label: `${val.nama}`
          }));
        }
        if (this.$router.currentRoute.params.idPasien) {
          if (this.formType == "edit") {
            if (this.tempat.kecamatan.kota_id !== this.tempat.kota.id) {
              this.tempat.kecamatan = null;
            }
          }
        } else if (this.kecamatanOption[0].kota_id !== this.tempat.kota) {
          this.tempat.kecamatan = null;
        }
      } catch (error) {}
    },
    async getKelurahan() {
      this.duplicateKtpDomisili();
      this.tempat.kelurahan = null;
      this.kelurahanOption = [];
      try {
        if (this.tempat.kecamatan != "" && !this.tempat.kecamatan != null) {
          const res = await this.$axios.get(
            `wilayah/desa?kecamatan_id=${this.tempat.kecamatan.id}`
          );
          // handle success
          this.kelurahanOption = res.data.data.map(val => ({
            ...val,
            label: `${val.nama}`
          }));
        }
        if (this.$router.currentRoute.params.idPasien) {
          if (this.formType == "edit") {
            if (
              this.tempat.kelurahan.kecamatan_id !== this.tempat.kecamatan.id
            ) {
              this.tempat.kelurahan = null;
            }
          }
        } else if (
          this.kelurahanOption[0].kecamatan_id !== this.tempat.kecamatan
        ) {
          this.tempat.kelurahan = null;
        }
      } catch (error) {}
    },
    setDataTempat() {
      this.kota_touched = true;
      this.formData["provinsi"] = this.tempat.provinsi.id;
      this.formData["kota"] = this.tempat.kota ? this.tempat.kota.id : null;
      this.getKecamatan();
    },
    setDataTempatKecamatan() {
      this.kecamatan_touched = true;
      this.formData["provinsi"] = this.tempat.provinsi.id;
      this.formData["kota"] = this.tempat.kota.id;
      this.formData["kecamatan"] = this.tempat.kecamatan
        ? this.tempat.kecamatan.id
        : null;
      this.getKelurahan();
    },
    setDataTempatKelurahan() {
      this.kelurahan_touched = true;
      this.duplicateKtpDomisili();
      this.formData["provinsi"] = this.tempat.provinsi.id;
      this.formData["kota"] = this.tempat.kota.id;
      this.formData["kecamatan"] = this.tempat.kecamatan.id;
      this.formData["kelurahan"] = this.tempat.kelurahan
        ? this.tempat.kelurahan.id
        : null;
    },
    async getCityDomi() {
      this.tempat_domisili.kota = null;
      this.tempat_domisili.kecamatan = null;
      this.tempat_domisili.kelurahan = null;
      this.cities_domi = [];
      this.kelurahanOption_domi = [];
      this.kecamatanOption_domi = [];
      try {
        var val;
        if (
          this.tempat_domisili.provinsi == "" ||
          this.tempat_domisili.provinsi == null
        ) {
          val = "";
        } else {
          val = this.tempat_domisili.provinsi.id;
          const res = await this.$axios.get(
            `getcitybyprovince/${val}`
          );
          // handle success
          this.cities_domi = res.data.data.kota.map(val => ({
            ...val,
            label: `${val.nama}`
          }));
        }
        if (this.$router.currentRoute.params.idPasien) {
          if (this.formType == "edit") {
            if (
              this.tempat_domisili.kota.provinsi_id !==
              this.tempat_domisili.provinsi.id
            ) {
              this.tempat_domisili.kota = null;
            }
          }
        } else if (
          this.cities_domi[0].provinsi_id !== this.tempat_domisili.provinsi
        ) {
          this.tempat_domisili.kota = null;
        }
      } catch (error) {}
    },
    async getKecamatanDomi() {
      this.tempat_domisili.kecamatan = null;
      this.tempat_domisili.kelurahan = null;
      this.kelurahanOption_domi = [];
      this.kecamatanOption_domi = [];
      try {
        var val;
        if (
          this.tempat_domisili.kota == "" ||
          this.tempat_domisili.kota == null
        ) {
          val = "";
        } else {
          val = this.tempat_domisili.kota.id;
          const res = await this.$axios.get(
            `wilayah/kecamatan?kota_id=${val}`
          );
          // handle success
          this.kecamatanOption_domi = res.data.data.map(val => ({
            ...val,
            label: `${val.nama}`
          }));
        }
        if (this.$router.currentRoute.params.idPasien) {
          if (this.formType == "edit") {
            if (
              this.tempat_domisili.kecamatan.kota_id !==
              this.tempat_domisili.kota.id
            ) {
              this.tempat_domisili.kecamatan = null;
            }
          }
        } else if (
          this.kecamatanOption_domi[0].kota_id !== this.tempat_domisili.kota
        ) {
          this.tempat_domisili.kecamatan = null;
        }
      } catch (error) {}
    },
    async getKelurahanDomi() {
      this.tempat_domisili.kelurahan = null;
      this.kelurahanOption_domi = [];
      try {
        if (
          this.tempat_domisili.kecamatan != "" &&
          !this.tempat_domisili.kecamatan != null
        ) {
          const res = await this.$axios.get(
            `wilayah/desa?kecamatan_id=${this.tempat_domisili.kecamatan.id}`
          );
          // handle success
          this.kelurahanOption_domi = res.data.data.map(val => ({
            ...val,
            label: `${val.nama}`
          }));
        }
        if (this.$router.currentRoute.params.idPasien) {
          if (this.formType == "edit") {
            if (
              this.tempat_domisili.kelurahan.kecamatan_id !==
              this.tempat_domisili.kecamatan.id
            ) {
              this.tempat_domisili.kelurahan = null;
            }
          }
        } else if (
          this.kelurahanOption_domi[0].kecamatan_id !==
          this.tempat_domisili.kecamatan
        ) {
          this.tempat_domisili.kelurahan = null;
        }
      } catch (error) {}
    },
    setDataTempatDomi() {
      this.formData["provinsi_domi"] = this.tempat_domisili.provinsi.id;
      this.formData["kota_domi"] = this.tempat_domisili.kota.id;
      this.getKecamatanDomi();
    },
    setDataTempatKecamatanDomi() {
      this.formData["provinsi_domi"] = this.tempat_domisili.provinsi.id;
      this.formData["kota_domi"] = this.tempat_domisili.kota.id;
      this.formData["kecamatan_domi"] = this.tempat_domisili.kecamatan.id;
      this.getKelurahanDomi();
    },
    setDataTempatKelurahanDomi() {
      this.formData["provinsi_domi"] = this.tempat_domisili.provinsi
        ? this.tempat_domisili.provinsi.id
        : null;
      this.formData["kota_domi"] = this.tempat_domisili.kota
        ? this.tempat_domisili.kota.id
        : null;
      this.formData["kecamatan_domi"] = this.tempat_domisili.kecamatan
        ? this.tempat_domisili.kecamatan.id
        : null;
      this.formData["kelurahan_domi"] = this.tempat_domisili.kelurahan
        ? this.tempat_domisili.kelurahan.id
        : null;
    },
    startCase: startCase,
    stupidOcrHelper({ alias, val }) {
      const mapGender = val => {
        const x = 1;
        return /empu|wan/gi.test(val) ? x * 0 : x;
      };

      switch (alias.toLowerCase()) {
        case "gender":
          return mapGender(val);

        default:
          return val;
      }
    },
    assignValuePasien(data) {
      if (data) {
        Object.keys(data).map(item => {
          const y = this.formBasicData.find(x => x.alias === item);
          if (y) {
            const { stupidOcrHelper } = this;
            Vue.set(
              this.formData,
              y.label,
              stupidOcrHelper({
                alias: y.alias,
                val: (() => {
                  if (y.label == "jenis_kelamin") {
                    if (data[item] == 0) {
                      return "Perempuan";
                    }
                    if (data[item] == 1) {
                      return "Laki-laki";
                    }
                    if (data[item] == 2) {
                      return "Tidak diketahui";
                    }
                    if (data[item] == 3) {
                      return "Tidak dapat ditentukan";
                    }
                    if (data[item] == 4) {
                      return "Tidak mengisi";
                    }
                  }
                  if (y.label == "no._handphone") {
                  }
                  return (
                    (typeof data[item] === "string" && data[item].trim()) ||
                    data[item]
                  );
                })()
              })
            );
          }
        });
      }
    },
    btnText() {
      switch (this.formType) {
        case "detail":
          return "tutup";

        case "edit":
          return "batal";

        default:
          return "keluar";
      }
    },
    btnVariant() {
      switch (this.formType) {
        case "detail":
          return "primary";

        default:
          return "danger";
      }
    },
    disabledForm() {
      return this.formType === "detail";
    },
    tanggalLahirSelected($event) {
      if (!$event) return;
      this.setValue({
        rawLabel: "tanggal lahir",
        $event: moment($event).format("YYYY-MM-DD")
      });
    },
    async getPasienData(idPasien) {
      try {
        const res = await this.$axios.get(
          `pasien/${idPasien}?klinik_id=${this.getKlinikId}`
        );
        const { status, data } = res.data;
        if (status) {
          this.dataPasien = data;
          if (data.bpjs_noka) {
            this.isBPJS = this.isEditBPJS = true;
            this.card_number.number = data.bpjs_noka;
            this.cek_anggota_bpjs = true;
            this.formData['bpjs_noka'] = data.bpjs_noka;
          }

          this.getPhonePrefix(data.nomor_hp_prefix);

          const { assignValuePasien } = this;
          var prev = data.tanggal_lahir;
          data.tanggal_lahir = new Date(prev);
          assignValuePasien(data);
          this.isForgotNikFromApi = data.is_forgot_no;
          this.checkBoDLessThan17(data.tanggal_lahir);

          this.synced = data.synced_to_satusehat == 1 ? true : false;
          this.satusehat_patient_id = data.satusehat_patient_id;
          this.alamatDomisiliSesuaiKTP = data.alamat_domisili_sesuai_ktp;

          this.tempat.provinsi = {
            ...data.provinsi,
            label: data.provinsi.provinsi_nama
          };
          this.getCity();
          this.tempat.kota = {
            ...data.kota,
            label: data.kota.nama
          };
          this.getKecamatan();
          this.tempat.kecamatan = {
            ...data.kecamatan,
            label: data.kecamatan.nama
          };
          this.getKelurahan();
          this.tempat.kelurahan = {
            ...data.kelurahan,
            label: data.kelurahan.nama
          };

          if(data.provinsi_domisili) {
            this.tempat_domisili.provinsi = {
              ...data.provinsi_domisili,
              label: data.provinsi_domisili.provinsi_nama
            };
            this.formData["provinsi_domi"] = data.provinsi_domisili.id;
          }

          if(data.kota_domisili) {
            this.getCityDomi();
            this.tempat_domisili.kota = {
              ...data.kota_domisili,
              label: data.kota_domisili.nama
            };
            this.formData["kota_domi"] = data.kota_domisili.id;
          }

          if(data.kecamatan_domisili) {
            this.getKecamatanDomi();
            this.tempat_domisili.kecamatan = {
              ...data.kecamatan_domisili,
              label: data.kecamatan_domisili.nama
            };
            this.formData["kecamatan_domi"] = data.kecamatan_domisili.id;
          }

          if(data.kelurahan_domisili) {
            this.getKelurahanDomi();
            this.tempat_domisili.kelurahan = {
              ...data.kelurahan_domisili,
              label: data.kelurahan_domisili.nama
            };
            this.formData["kelurahan_domi"] = data.kelurahan_domisili.id;
          }

          this.formData["nomor_hp_prefix"] = data.nomor_hp_prefix;
          this.formData["no._KTP_ibu_kandung"] = data.nik_ibu;

          if (this.pcareVersion == '1') {
            this.formData['ket_riwayat_alergi_makanan'] = data.ket_riwayat_alergi_makanan;
            this.formData['ket_riwayat_alergi_obat'] = data.ket_riwayat_alergi_obat;
            this.formData['riwayat_alergi_makanan'] = this.optAlergiMakanan.find(v => v.value == data.alergi_makanan_bpjs);
            this.formData['riwayat_alergi_udara'] = this.optAlergiUdara.find(v => v.value == data.alergi_udara_bpjs);
            this.formData['riwayat_alergi_obat'] = this.optAlergiObat.find(v => v.value == data.alergi_obat_bpjs);
          }
        }
      } catch (err) {
        // alert(err)
      }
    },
    whitelistValidation() {
      return this.setFormBasicData()
        .filter(item => item.validations && !item.validations.required)
        .map(item => item.rawLabel);
    },
    setFormData() {
      return this.setFormBasicData().reduce((arr, val) => {
        let key = val.label.split(" ").join("_");
        arr[key] = "";
        return arr;
      }, {});
    },
    setFormBasicData() {
      return tmp.map((item, index) => ({
        ...item,
        label: item.label.split(" ").join("_"),
        tmpId: index,
        error: null,
        rawLabel: item.label
      }));
    },
    checkInput({ rawLabel, $event }) {
      const { key } = $event;
      var evt = $event;
      evt = evt ? evt : window.event;
      if (/[^a-zA-Z0-9\-\.]/.test(key)) {
        evt.preventDefault();
      } else {
        return;
      }
    },
    onKeyInputNumberSpecial({ rawLabel, $event }) {
      var evt = $event;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode == 37 ||
        charCode == 38 ||
        charCode == 39 ||
        charCode == 40 ||
        charCode == 8 ||
        charCode == 46 ||
        charCode == 9 ||
        charCode == 17 ||
        charCode == 86
      ) {
        return;
      }

      if (!evt.key.match(/[0-9,.]/)) {
        evt.preventDefault();
      }
    },
    onKeyInputPreventSymbol({ $event }) {
      var evt = $event;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;

      if (
        charCode == 37 ||
        charCode == 38 ||
        charCode == 39 ||
        charCode == 40 ||
        charCode == 8 ||
        charCode == 46 ||
        charCode == 9
      ) {
        return;
      }

      // Only prevent symbols
      if (evt.key.match(/[^\w\s]/)) {
        evt.preventDefault();
      }
    },
    onKeyInputNumber({ rawLabel, $event }) {
      var evt = $event;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        void this.setValue({
          rawLabel,
          $event
        });
      }
    },
    setValue({ rawLabel, $event = null } = {}) {
      this.duplicateKtpDomisiliInputField();
      let value = $event;
      const label = rawLabel.split(" ").join("_");
      if (typeof $event === "object") {
        if ($event) {
          if (this.pcareVersion == '1' && ['riwayat_alergi_makanan','riwayat_alergi_udara','riwayat_alergi_obat'].includes(label)) {
            this.formData[label] = $event;
          } else {
            const {
              target: { value }
            } = $event;
            this.formData[label] = value;
          }
        } else {
          this.formData[label] = null;
        }
      } else {
        this.formData[label] = value;
      }

      this.triggerValidation({
        label,
        $v: this.$v,
        $vm: this,
        rawLabel
      });
    },
    openSection1() {
      this.visible_section_1 = true;
      this.visible_section_3 = false;
      this.visible_section_4 = false;
      this.visible_section_5 = false;
      this.visible_section_6 = false;
      this.visible_section_2 = false;
    },
    openSection2() {
      this.visible_section_1 = false;
      this.visible_section_2 = true;
      this.visible_section_3 = false;
      this.visible_section_4 = false;
      this.visible_section_5 = false;
      this.visible_section_6 = false;
    },
    openSection6() {
      this.visible_section_1 = false;
      this.visible_section_2 = false;
      this.visible_section_3 = false;
      this.visible_section_4 = false;
      this.visible_section_5 = false;
      this.visible_section_6 = true;
    },
    submitForm() {
      this.noIdentitasTouch = true;
      this.noIdentitasIbuTouch = true;
      this.nama_touched = true,
      this.tempat_lahir_touched = true,
      this.handphone_touched = true,
      this.alamat_rumah_touched = true,
      this.negara_touched = true;
      this.provinsi_touched = true;
      this.kota_touched = true;
      this.kecamatan_touched = true;
      this.kelurahan_touched = true;
      const { formBasicData } = this;
    
      formBasicData.forEach(item => {
          this.triggerValidation({
            label: item.label,
            $v: this.$v,
            $vm: this,
            rawLabel: item.rawLabel
          });
      });

      if (this.isBPJS) {
        this.onCardNumber();
      } else {
        this.formData["bpjs_noka"] = this.card_number.number;
      }

      if (this.isBPJS && this.card_number.number && !this.cek_anggota_bpjs) {
        return this.$swal({
          text: `Mohon lakukan cek anggota BPJS terlebih dahulu`,
          type: "error",
          showCancelButton: false,
          confirmButtonText: startCase("ya")
        });
      }
      if (this.pcareVersion == '1' && this.alergi.makanan_lain) {
        let ket_makanan = this.formData['ket_riwayat_alergi_makanan'];
        if (!ket_makanan || ket_makanan == '' || ket_makanan == undefined) this.alergi.ket_makanan_lain = true;
        else this.alergi.ket_makanan_lain = false;
      }
      if (this.pcareVersion == '1' && this.alergi.obat_lain) {
        let ket_obat = this.formData['ket_riwayat_alergi_obat'];
        if (!ket_obat || ket_obat == '' || ket_obat == undefined) this.alergi.ket_obat_lain = true;
        else this.alergi.ket_obat_lain = false;
      }

      if (
        formBasicData.every(item => item.error !== null && !item.error) &&
        !this.card_number.error &&
        [null, true].includes(this.stateNoIdentitas) &&
        [null, true].includes(this.stateNoIdentitasIbu) &&
        this.stateNegara &&
        this.stateProvinsi &&
        this.stateKota &&
        this.stateKecamatan &&
        this.stateKelurahan &&
        !this.alergi.ket_makanan_lain &&
        !this.alergi.ket_obat_lain
      ) {
        if (this.formData.provinsi) {
          this.formData.provinsi =
            this.tempat.provinsi && this.tempat.provinsi.id
              ? this.tempat.provinsi.id
              : null;
          this.formData.kota =
            this.tempat.kota && this.tempat.kota.id
              ? this.tempat.kota.id
              : null;
          this.formData.kecamatan =
            this.tempat.kecamatan && this.tempat.kecamatan.id
              ? this.tempat.kecamatan.id
              : null;
          this.formData.kelurahan =
            this.tempat.kelurahan && this.tempat.kelurahan.id
              ? this.tempat.kelurahan.id
              : null;
        }

        let noHpModifed = this.formData["no._handphone"];

        if (this.noHpType) {
          noHpModifed = `${this.formData["no._handphone"]}`;
        }

        this.formData.nomor_hp_prefix = this.noHpType.value;

        let riwayat = {
          riwayat_alergi_makanan: this.formData['riwayat_alergi_makanan'],
          riwayat_alergi_obat: this.formData['riwayat_alergi_obat'],
          riwayat_alergi_udara: this.formData['riwayat_alergi_udara'],
          alergi_makanan_bpjs: this.dataPasien ? this.dataPasien.alergi_makanan_bpjs : null,
          alergi_obat_bpjs: this.dataPasien ? this.dataPasien.alergi_obat_bpjs : null,
          alergi_udara_bpjs: this.dataPasien ? this.dataPasien.alergi_udara_bpjs : null,
        }
        if (this.pcareVersion == '1') {
          if (typeof this.formData['riwayat_alergi_makanan'] == 'object') {
            riwayat.riwayat_alergi_makanan = this.formData['riwayat_alergi_makanan'].label || null;
            riwayat.alergi_makanan_bpjs = this.formData['riwayat_alergi_makanan'].value || null;
          }
          if (typeof this.formData['riwayat_alergi_obat'] == 'object') {
            riwayat.riwayat_alergi_obat = this.formData['riwayat_alergi_obat'].label || null;
            riwayat.alergi_obat_bpjs = this.formData['riwayat_alergi_obat'].value || null;
          }
          if (typeof this.formData['riwayat_alergi_udara'] == 'object') {
            riwayat.riwayat_alergi_udara = this.formData['riwayat_alergi_udara'].label || null;
            riwayat.alergi_udara_bpjs = this.formData['riwayat_alergi_udara'].value || null;
          }
        }

        this.$emit("submitForm", {
          ...this.formData,
          ...riwayat,
          tanggal_lahir: moment(this.formData.tanggal_lahir).format(
            "YYYY-MM-DD"
          ),
          addToAntrean: this.isAntrean,
          "no._handphone": noHpModifed,
          satusehat_patient_id: this.satusehat_patient_id,
          synced_to_satusehat: this.synced ? 1 : 0,
          alamat_domisili_sesuai_ktp: this.alamatDomisiliSesuaiKTP,
          isForgotNik: this.isForgotNik ? 1 : 0,
          isLessThan17: this.isLessThan17,
          nik_ibu: this.formData['no._KTP_ibu_kandung']
        });
      } else {
        let fieldErros = "";
        this.section1Error = false;
        this.section2Error = false;
        this.section6Error = false;
        formBasicData.forEach(elForm => {
          if (
            elForm.error &&
            elForm.validations.hasOwnProperty("required") &&
            !this.formData[`${elForm.label}`]
          ) {
            if (elForm.rawLabel !== "alamat rumah") {
              this.section1Error = true;
              fieldErros += `${elForm.rawLabel.toLowerCase()}, `;
            }
          }

          if (elForm.rawLabel == "jenis identitas" && ![null, true].includes(this.stateNoIdentitas)) {
            fieldErros += `no. identitas, `;
            this.section1Error = true;
          }

          if (elForm.rawLabel == "tempat lahir" && !this.stateNegara) {
            fieldErros += `negara, `;
            this.section2Error = true;
          }
          if (elForm.rawLabel == "tempat lahir" && !this.stateProvinsi) {
            fieldErros += `provinsi, `;
            this.section2Error = true;
          }
          if (elForm.rawLabel == "tempat lahir" && !this.stateKota) {
            fieldErros += `kota, `;
            this.section2Error = true;
          }
          if (elForm.rawLabel == "tempat lahir" && !this.stateKecamatan) {
            fieldErros += `kecamatan, `;
            this.section2Error = true;
          }
          if (elForm.rawLabel == "tempat lahir" && !this.stateKelurahan) {
            fieldErros += `kelurahan, `;
            this.section2Error = true;
          }
          if (elForm.rawLabel == "tempat lahir" && formBasicData[11].error) {
            fieldErros += `alamat lengkap, `;
            this.section2Error = true;
          }
          if (elForm.rawLabel == "riwayat alergi makanan" && this.alergi.ket_makanan_lain) {
            fieldErros += `keterangan riwayat alergi makanan lain, `;
            this.section6Error = true;
          }
          if (elForm.rawLabel == "riwayat alergi obat" && this.alergi.ket_obat_lain) {
            fieldErros += `keterangan riwayat alergi obat lain, `;
            this.section6Error = true;
          }
        });
        fieldErros = fieldErros && fieldErros.slice(0, -2);

        let popupErrors = "Silakan lengkapi kolom yang harus diisi!";

        if (fieldErros) {
          popupErrors = `Oops..! Ada kolom yang belum terisi!<br>Lengkapi kolom ${fieldErros} sebelum menyimpan data!`;
        }

        this.$swal({
          html: popupErrors,
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "OK",
          scrollbarPadding: false,
          onAfterClose: toast => {
            if (this.formBasicData[1].error) {
              this.openSection1();
              this.$nextTick(() => {
                this.$refs.nama_lengkap.focus();
              });
            } else if (this.formBasicData[2].error) {
              this.openSection1();
              this.$nextTick(() => {
                this.$refs.no_handphone.focus();
              });
            } else if (![null, true].includes(this.stateNoIdentitas)) {
              this.openSection1();
              this.$nextTick(() => {
                this.$refs.nik.focus();
              });
            } else if (![null, true].includes(this.stateNoIdentitasIbu)) {
              this.openSection1();
              this.$nextTick(() => {
                this.$refs.nik_ibu.focus();
              });
            } else if (this.card_number.error) {
              this.openSection1();
              this.$nextTick(() => {
                this.$refs.card_number.focus();
              });
              21;
            } else if (
              this.formBasicData[5].error ||
              this.formBasicData[6].error
            ) {
              this.openSection1();
            } else if (this.formBasicData[21].error) {
              this.openSection1();
              this.$nextTick(() => {
                this.$refs.tempat_lahir.focus();
              });
            } else if (
              !this.stateNegara ||
              !this.stateProvinsi ||
              !this.stateKota ||
              !this.stateKecamatan ||
              !this.stateKelurahan
            ) {
              this.openSection2();
            } else if (this.formBasicData[11].error) {
              this.openSection2();
              this.$nextTick(() => {
                this.$refs.alamat.focus();
              });
            } else if (this.alergi.ket_makanan_lain) {
              this.openSection6();
              this.$nextTick(() => {
                this.$refs.ket_riwayat_alergi_makanan.focus();
              });
            } else if (this.alergi.ket_obat_lain) {
              this.openSection6();
              this.$nextTick(() => {
                this.$refs.ket_riwayat_alergi_obat.focus();
              });
            }
          }
        });
      }
    },
    onCardNumber() {
      let number = this.card_number.number;
      if (number === null) {
        return;
      }
      if (number.length == 13 || number.length == 16 || number.length == 0) {
        this.card_number.error = false;
        this.card_number.message = null;
      } else {
        this.card_number.error = true;
        this.card_number.message = "Nomor tidak sesuai";
      }
    },
    onKeyInputNumberBPJS({ $event }) {
      var evt = $event;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      }
    },
    async cekPesertaBPJS() {
      this.onCardNumber();

      if (
        !this.bpjsAuthValid ||
        this.card_number.error ||
        this.card_number.number === null ||
        this.card_number.number === ""
      ) {
        return;
      }

      const res = await this.$axios.post(`bpjs/peserta`, {
        klinik_id: this.getKlinikId,
        card_number: this.card_number.number
      });
      const { status, data } = res.data;

      if (status) {
        if (!data.aktif) {
          this.$swal({
            html: `Peserta tidak aktif <br> Keterangan: ${data.ketAktif}`,
            type: "warning",
            showCancelButton: false,
            confirmButtonText: "OK"
          });
          return;
        }

        this.$swal({
          text: "Peserta aktif",
          type: "success",
          showCancelButton: false,
          confirmButtonText: "OK"
        }).then(res => {
          if (res.value) {
            this.setFormDataBPJS(data.detail_peserta);
          }
        });
      } else {
        this.$swal({
          text: "Gagal cek data peserta",
          type: "error",
          showCancelButton: false,
          confirmButtonText: "OK"
        });
      }
    },
    setFormDataBPJS(data) {
      this.cek_anggota_bpjs = true;
      this.formData = this.setFormData();
      this.tempat = {
        negara: null,
        provinsi: null,
        kota: null,
        kecamatan: null,
        kelurahan: null
      };
      this.dataBPJS = data;
      this.formData["bpjs_noka"] = data.noKartu || null;
      this.formData["nama"] = data.nama || null;
      this.formData["nama_lengkap"] = data.nama || null;
      this.formData["no._handphone"] = data.noHP || null;
      this.formData["tanggal_lahir"] = data.tglLahir
        ? moment(
            data.tglLahir
              .split("-")
              .reverse()
              .join("-")
          ).toDate()
        : null;
      this.formData["gol._darah"] = data.golDarah == "0" ? "O" : data.golDarah;
      if (data.noKTP) {
        this.formData["nik"] = data.noKTP;
        this.formData["jenis_identitas"] = "KTP";
      }
      if (data.sex) {
        if (["L", "l"].includes(data.sex)) {
          this.formData["jenis_kelamin"] = "Laki-laki";
        } else {
          this.formData["jenis_kelamin"] = "Perempuan";
        }
      }

      // remove is-valid
      Object.keys(this.formData).forEach(item => {
        if (
          [
            "No._RM_Manual",
            "nama_lengkap",
            "no._handphone",
            "nik",
            "paspor",
            "kitas",
            "alamat_rumah"
          ].includes(item)
        ) {
          if (item == "nik" && !this.formData["nik"]) {
            [
              "nik",
              "nik_paspor",
              "nikn",
              "nikn_paspor",
              "nike",
              "nike_paspor",
              "nik_kitas",
              "paspor",
              "kitas"
            ].forEach(n => {
              if (document.getElementById(n))
                document.getElementById(n).classList.remove("is-valid");
            });
          } else if (item != "nik" && !this.formData[item]) {
            if (document.getElementById(item))
              document.getElementById(item).classList.remove("is-valid");
          }
        }
      });

      const { formBasicData } = this;

      formBasicData.map(item => {
        this.triggerValidation({
          label: item.label,
          $v: this.$v,
          $vm: this,
          rawLabel: item.rawLabel
        });
      });
    },
    checkLain(type) {
      this.alergi[`${type}_lain`] = false;
      if (this.pcareVersion == '1' && this.checkValueData(this.formData[`riwayat_alergi_${type}`])) {
        let value = this.formData[`riwayat_alergi_${type}`].label;
        if (value && value.toLowerCase().includes('lain')) {
          this.alergi[`${type}_lain`] = true;
          return true;
        }
      }
      return false;
    },
  }
};
</script>

<style>
#fileInput {
  display: none;
  position: absolute;
}

.text-foto {
  width: 100%;
  background-color: #f2f3f4;
  padding: 15px;
  border-radius: 15px;
  margin-top: 30px;
  z-index: 999;
}

.text-foto:hover {
  background-color: #d5d8dc;
}

.overlay-upload {
  top: 0px;
  left: 0px;
  background-image: linear-gradient(
    rgba(255, 255, 255, 0),
    rgba(0, 0, 0, 0.5) 83%,
    rgba(0, 0, 0, 0.8)
  );
  width: 100%;
  height: auto;
  position: absolute;
}

.btn_confirm_cek_peserta {
  margin-top: 0 !important;
}
.rotate-0 {
  transform: rotate(0deg);
  transition: transform 0.3s ease; /* You can adjust the duration and timing function as needed */
}

.rotate-90 {
  transform: rotate(-90deg);
  transition: transform 0.3s ease; /* You can adjust the duration and timing function as needed */
}
.cal-pos {
  float: right !important;
  position: absolute;
  right: 15px;
  top: 42px;
  color: gray;
}
.pos-relative {
  position: relative;
}
.text-red {
  color: red;
}
.pointer {
  cursor: pointer;
}
.c-default {
  cursor: default;
}
.fs-17-5 {
  font-size: 17.5px;
}
.fs-24 {
  font-size: 24px;
}
.fs-27 {
  font-size: 27px;
}
.sync-satusehat {
  display: flex;
  align-items: center;
}
.fc-synced {
  color: #1ad52f;
}
.fc-sync {
  color: #3772d7;
}
.op-3 {
  opacity: 0.3;
  }
</style>

<style lang="scss">
.foto-upload {
  & .text-foto {
    cursor: pointer;
  }
}

.top_form {
  top: -10px;
}

.btn_bpjs {
  margin-top: 1.3rem !important;
}

.top_form_err {
  top: -7px;
}

#noHpTypeId .vs__dropdown-toggle {
  border-radius: 5px 0px 0px 5px;
}

#noHpTypeId .vs__dropdown-menu {
  min-width: 110px;
}

.section-error {
  border-style: solid;
  border-color: red;
  padding: 16px;
  border-radius: 10px;
  border-width: 3px;
  margin-bottom: 10px;
}
</style>
